<template>
  <div class="w-full" style="min-height: 1000px;">
    <!-- Ramadan Special Section -->
    <!-- <homeRamadanSection /> -->
    
    <!-- Hero section -->
    <section class="hero-section md:mt-6 w-full relative grid content-end max-w-full">
      <HomeHeroCarousel />
    </section>

    <!-- ======= TOUR SEARCH FILTER BAR ======= -->
    <section class="tour-filter-bar w-full relative z-10 -mt-2 sm:-mt-10" aria-labelledby="tour-filter-title">
      <div class="max-w-screen-lg xl:max-w-screen-xl mx-auto px-3 sm:px-5 2xl:px-0">
        <div class="tour-filter-card rounded-2xl border border-white/10 bg-white backdrop-blur-lg shadow-[0_28px_56px_-20px_rgba(22,32,51,0.92)] px-4 md:px-6 pt-4 pb-5">

          <!-- Bar header -->
          <div class="filter-heading flex items-center gap-2">
            <span class="flex h-8 w-8 items-center justify-center rounded-full bg-accent-500/15">
              <font-awesome-icon icon="fa-solid fa-sliders" class="w-3 h-3 text-accent-600" />
            </span>
            <div>
              <p id="tour-filter-title" class="text-sm font-bold text-accent-600 uppercase tracking-widest mb-0">{{ pageCopy.filterTitle }}</p>
              <p class="filter-subtitle mb-0 text-[11px] text-slate-500">{{ pageCopy.filterSubtitle }}</p>
            </div>
          </div>

          <!-- Main filter row -->
          <div class="flex flex-col lg:flex-row lg:items-end gap-3">

            <!-- Month pills -->
            <div class="flex-1 min-w-0">
              <label class="block text-[13px] text-slate-600 font-semibold mt-2 md:mt-0 mb-2 flex items-center gap-1.5">
                <font-awesome-icon icon="fa-solid fa-calendar-days" class="w-3 h-3 text-accent-400" />
                {{ pageCopy.selectMonth }}
              </label>
              <div class="filter-month-list flex flex-wrap gap-1.5">
                <button
                  v-for="m in filterMonths"
                  :key="m.value"
                  type="button"
                  @click="toggleFilterMonth(m.value)"
                  :class="isFilterMonthSelected(m.value)
                    ? 'border-accent-400 bg-primary-500 text-white shadow-[0_0_14px_rgba(180,122,22,0.45)]'
                    : 'border-white/15 text-slate-600 hover:bg-white/10 hover:text-white hover:border-white/30'"
                  class="filter-month-pill text-[11px] font-semibold bg-slate-100 hover:bg-primary-500 px-3 py-1.5 
                  rounded-xl border transition-all duration-200 select-none"
                >
                  {{ m.label }}
                </button>
              </div>
            </div>

            <!-- Room based people selection -->
            <div class="filter-room-section flex-1 min-w-0">
              <div class="filter-room-summary flex items-center justify-between mb-2">
                <label class="text-[13px] hidden md:flex text-slate-600 font-semibold  items-center gap-1.5">
                  <font-awesome-icon icon="fa-solid fa-bed" class="w-3 h-3 text-accent-400" />
                  {{ pageCopy.roomAndGuests }}
                </label>
                <div class="flex items-center gap-2">
                  <p class="mb-0 text-[10px] sm:text-[11px] text-slate-500 font-medium whitespace-nowrap">
                    {{ filterTotals.rooms }} {{ pageCopy.room }} • {{ filterTotals.adults }} {{ pageCopy.adult }} • {{ totalFilterKidsCount }} {{ pageCopy.child }}
                  </p>
                  <button
                    type="button"
                    @click="addFilterRoom"
                    class="inline-flex items-center gap-1 text-[11px] font-semibold text-accent-600 hover:text-accent-700 transition"
                  >
                    <font-awesome-icon icon="fa-solid fa-plus" class="w-3 h-3" />
                    {{ pageCopy.addRoom }}
                  </button>
                </div>
              </div>

              <div class="filter-room-list space-y-1.5 max-h-[164px] overflow-auto pr-1">
                <div
                  v-for="(room, idx) in tourFilter.rooms"
                  :key="`home_filter_room_${idx}`"
                  class="filter-room-card rounded-lg border border-neutral-300 bg-white px-2 py-1.5"
                >
                  <div class="filter-room-grid flex items-center gap-1.5">
                    <span class="filter-room-name w-[40px] shrink-0 text-[10px] font-semibold text-neutral-700">{{ idx + 1 }}. {{ pageCopy.room }}</span>

                    <label class="filter-guest-field flex items-center gap-1">
                      <span class="text-[10px] text-neutral-700 font-medium">{{ pageCopy.adult }}</span>
                      <select v-model.number="room.adult" :aria-label="`${idx + 1}. ${pageCopy.adultCount}`" class="h-7 rounded-md border border-neutral-300 bg-neutral-100 px-1.5 text-[11px] text-neutral-700 font-semibold min-w-[44px]">
                        <option v-for="n in 3" :key="`adult_${idx}_${n}`" :value="n">{{ n }}</option>
                      </select>
                    </label>

                    <label class="filter-guest-field flex items-center gap-1">
                      <span class="text-[10px] text-neutral-700 font-medium">{{ pageCopy.child }}</span>
                      <select v-model.number="room.child" :aria-label="`${idx + 1}. ${pageCopy.childCount}`" class="h-7 rounded-md border border-neutral-300 bg-neutral-100 px-1.5 text-[11px] text-neutral-700 font-semibold min-w-[44px]">
                        <option v-for="n in 4" :key="`child_${idx}_${n}`" :value="n - 1">{{ n - 1 }}</option>
                      </select>
                    </label>

                    <label class="filter-guest-field flex items-center gap-1">
                      <span class="text-[10px] text-neutral-700 font-medium">{{ pageCopy.baby }}</span>
                      <select v-model.number="room.baby" :aria-label="`${idx + 1}. ${pageCopy.babyCount}`" class="h-7 rounded-md border border-neutral-300 bg-neutral-100 px-1.5 text-[11px] text-neutral-700 font-semibold min-w-[44px]">
                        <option v-for="n in 4" :key="`baby_${idx}_${n}`" :value="n - 1">{{ n - 1 }}</option>
                      </select>
                    </label>

                    <button
                      v-if="idx !== 0"
                      type="button"
                      @click="removeFilterRoom(idx)"
                      class="ml-auto text-neutral-500 hover:text-rose-500 transition"
                      :aria-label="pageCopy.removeRoom"
                    >
                      <font-awesome-icon icon="fa-solid fa-trash" class="w-3 h-3" />
                    </button>
                  </div>
                </div>
              </div>

            </div>

            <!-- Actions -->
            <div class="shrink-0 w-full lg:w-auto flex flex-row lg:flex-col gap-2">
              <button
                type="button"
                @click="doTourSearch"
                class="filter-search-btn h-[40px] sm:h-[44px] w-full lg:w-[150px] px-5 rounded-xl bg-slate-700 hover:bg-accent-600 active:scale-95 text-white font-bold text-sm flex items-center justify-center gap-2 transition-all duration-200"
              >
                <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="w-4 h-4" />
                {{ pageCopy.searchTours }}
              </button> 
            </div>

          </div>

          <!-- Child ages (visible when children > 0) -->
          <Transition name="filter-ages">
            <div v-if="tourFilter.childrenAges.length > 0" class="mt-3 pt-3 border-t border-white/10">
              <p class="text-[11px] text-slate-500 font-semibold mb-2 flex items-center gap-1.5">
                <font-awesome-icon icon="fa-solid fa-circle-info" class="w-3 h-3 text-support-400" />
                {{ pageCopy.childAges }}
              </p>
              <div class="flex flex-wrap gap-1.5">
                <div
                  v-for="(age, idx) in tourFilter.childrenAges"
                  :key="idx"
                  class="flex items-center gap-1.5 rounded-lg bg-slate-100 border border-white/15 px-2 py-1.5 hover:border-accent-400/40 transition"
                >
                  <span class="text-[11px] text-slate-400 font-medium shrink-0">{{ idx + 1 }}. {{ pageCopy.child }}</span>
                  <select
                    v-model="tourFilter.childrenAges[idx]"
                    class="filter-age-select bg-slate-100 py-1 px-2 text-slate-700 text-xs font-semibold outline-none cursor-pointer min-w-[72px]"
                  >
                    <option value="" class="bg-brand-900 text-white">{{ pageCopy.selectAge }}</option>
                    <option v-for="age in 18" :key="age - 1" :value="age - 1" class="bg-brand-900 text-white">
                      {{ age - 1 === 0 ? `0 (${pageCopy.babyLower})` : `${age - 1} ${pageCopy.age}` }}
                    </option>
                  </select>
                  <button
                    type="button"
                    @click="removeFilterChildAge(idx)"
                    class="text-neutral-500 hover:text-rose-400 transition ml-1"
                    :aria-label="pageCopy.removeChild"
                  >
                    <font-awesome-icon icon="fa-solid fa-xmark" class="w-3 h-3" />
                  </button>
                </div>
              </div>
            </div>
          </Transition>

        </div>
      </div>
    </section>
    <!-- ======= END TOUR SEARCH FILTER BAR ======= -->

    <HomeTrustRibbon />

    <Teleport to="body" :disabled="isMobile && selectionWhenShow ? false : true">
      <div v-if="isMobile && selectionWhenShow" class="z-50 w-full h-screen absolute top-0 left-0 ">

        <div class="flex justify-center items-center w-full h-screen ">
          <div
            class="w-11/12 lg:w-8/12 shadow p-4 rounded-md bg-white flex flex-col md:flex-row flex-wrap z-20 absolute py-8">
            <div class="w-full md:w-5/12 flex-none">
              <span class="mb-2 block text-xs font-semibold">{{ $t('Zaman seçiniz') }}</span>
              <div class="flex flex-wrap w-full ">
                <template v-for="item in searchQuestions['when']">
                  <div @click="addSearch('when', item.id)"
                    :class="item.selected ? 'border-green-200 bg-green-100' : 'border-slate-200 '"
                    class="rounded-lg mr-1 text-xs  cursor-pointer p-1 my-0.5 border block">{{ $t(item.label) }}</div>
                </template>
              </div>
            </div>
            <div class="w-full md:w-5/12  flex-none">
              <span class="mt-2 md:mt-0 text-xs mb-2 block text-xs font-semibold">{{ $t('Süre seçiniz') }}</span>
              <div class="flex flex-wrap w-full">
                <template v-for="item in searchQuestions['duration']">
                  <div @click="addSearch('duration', item.id)"
                    :class="item.selected ? 'border-green-200 bg-green-100' : 'border-slate-200 '"
                    class="rounded-lg mr-1 text-xs  cursor-pointer p-1 my-0.5 border block">{{ $t(item.label) }}</div>
                </template>
              </div>
            </div>
            <div class="block">
              <div class="flex my-2">
                <button type="button" @click="startSearch()" :aria-label="pageCopy.searchTours"
                  class="bg-green-600 rounded-xl md:rounded-7xl w-full md:w-[110px] h-[40px] md:h-[55px] flex items-center justify-center text-white text-xl   rounded-r-md">
                  <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="h-4 w-4"></font-awesome-icon>
                </button>
              </div>
              <div class="absolute -top-5 -right-5">
                <GlobalButton @click="selectionWhenShow = false" label="" size="2xl" rounded="full" variant="light"
                  color="slate" icon="fa-solid fa-times" class="py-2"> </GlobalButton>
              </div>
            </div>


          </div>
        </div>
        <div @click="selectionWhenShow = false"
          class="bg-slate-800  opacity-90  z-10 w-full h-screen absolute top-0 left-0">
        </div>
      </div>
    </Teleport>
<section class="transform pt-0">
   
  <section class="sm:hidden w-full mx-auto px-4 md:px-0.5 py-2 mb-2">
    <div class="-mr-4 flex snap-x snap-mandatory gap-3 overflow-x-auto px-4 pb-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      <div v-for="card in promoCards" :key="card.id" class="w-[84%] max-w-[320px] shrink-0 snap-start">
        <a :href="getPath(card.path)" :class="['home-program-card home-program-card--mobile group', `home-program-card--${card.tone}`]" @click.prevent="goPath(card.path)">
          <span class="home-program-card__accent" aria-hidden="true"></span>
          <div class="mb-4 flex items-center justify-between gap-3">
            <span class="home-program-card__icon"><font-awesome-icon :icon="card.icon" class="h-4 w-4" /></span>
            <span v-if="card.badge" class="home-program-card__badge">{{ card.badge }}</span>
          </div>
          <p class="home-program-card__eyebrow">{{ card.eyebrow }}</p>
          <h3 class="home-program-card__title">{{ card.title }}</h3>
          <p class="home-program-card__subtitle">{{ card.subtitle }}</p>
          <ul class="home-program-card__features" :aria-label="card.title">
            <li v-for="item in card.mobileBullets.slice(0, 2)" :key="item"><font-awesome-icon icon="fa-solid fa-check" /><span>{{ item }}</span></li>
          </ul>
          <span class="home-program-card__cta">{{ card.cta }} <font-awesome-icon icon="fa-solid fa-arrow-right" class="h-3 w-3" /></span>
        </a>
      </div>
    </div>
  </section>

  <section class="home-priority-grid hidden sm:block w-full max-w-screen-xl mx-auto px-6 lg:px-8 2xl:px-0 py-2 sm:py-3 mb-2">
    <div class="grid w-full grid-cols-1 lg:grid-cols-12 gap-2.5 md:gap-4 items-stretch">
      <div class="lg:col-span-12 grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4">
        <a v-for="card in promoCards" :key="card.id" :href="getPath(card.path)" :class="['home-program-card group', `home-program-card--${card.tone}`]" @click.prevent="goPath(card.path)">
          <span class="home-program-card__accent" aria-hidden="true"></span>
          <div class="mb-4 flex items-center justify-between gap-3">
            <span class="home-program-card__icon"><font-awesome-icon :icon="card.icon" class="h-4 w-4" /></span>
            <span v-if="card.badge" class="home-program-card__badge">{{ card.badge }}</span>
          </div>
          <p class="home-program-card__eyebrow">{{ card.eyebrow }}</p>
          <h3 class="home-program-card__title">{{ card.title }}</h3>
          <p class="home-program-card__subtitle">{{ card.subtitle }}</p>
          <ul class="home-program-card__features" :aria-label="card.title">
            <li v-for="item in card.desktopBullets.slice(0, 2)" :key="item"><font-awesome-icon icon="fa-solid fa-check" /><span>{{ item }}</span></li>
          </ul>
          <span class="home-program-card__cta">{{ card.cta }} <font-awesome-icon icon="fa-solid fa-arrow-right" class="h-3 w-3" /></span>
        </a>
      </div>

      <!-- <div class="lg:col-span-5">
        <div class="relative h-full min-h-[392px] overflow-hidden rounded-2xl border border-brand-300/45 bg-brand-900/90 shadow-[0_22px_34px_-20px_rgba(22,32,51,0.45)]">
          <template v-if="showHomePromoVideo">
            <video
              class="absolute inset-0 h-full w-full object-cover"
              autoplay
              loop
              playsinline
              controls
              preload="metadata"
              poster="/assets/img/video_hac.webp"
            >
              <source src="/assets/video/video-konusmaci.mp4" type="video/mp4" />
            </video>
          </template>
          <button
            v-else
            type="button"
            @click="startHomePromoVideo"
            class="group absolute inset-0 block w-full text-left"
            aria-label="Videoyu oynat"
          >
            <img
              src="/assets/img/slider/mecca-kaba.jpg"
              alt="Mekke Kabe"
              class="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div class="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/80"></div>
            <div class="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.14)_0%,rgba(0,0,0,0)_45%)]"></div>

            <div class="absolute left-4 top-4 z-10 flex flex-wrap items-center gap-2 md:left-5 md:top-5">
              <span class="inline-flex items-center rounded-full border border-accent-300/70 bg-accent-500/25 px-2.5 py-1 text-[11px] font-semibold text-accent-100 backdrop-blur-sm">Premium İçerik</span>
              <span class="inline-flex items-center rounded-full border border-white/35 bg-black/30 px-2.5 py-1 text-[11px] font-semibold text-white backdrop-blur-sm">Yeni Dönem</span>
            </div>

            <div class="absolute inset-x-0 top-1/2 z-10 flex -translate-y-1/2 justify-center px-4">
              <span class="relative inline-flex h-20 w-20 items-center justify-center rounded-full border border-white/45 bg-white/15 text-white backdrop-blur-md transition duration-300 group-hover:scale-110 group-hover:bg-white/25">
                <span class="absolute h-full w-full animate-ping rounded-full border border-white/35"></span>
                <font-awesome-icon icon="fa-solid fa-play" class="relative ml-1 h-7 w-7" />
              </span>
            </div>

            <div class="absolute inset-x-0 bottom-0 z-10 p-4 md:p-6">
              <h3 class="text-xl leading-7 text-white md:text-2xl md:leading-8 font-semibold max-w-[95%] md:max-w-[90%] mb-0">
                Yeni Dönem Umre Programlarımızda Neler Sunuyoruz?
              </h3>
              <p class="mb-0 mt-1.5 text-[12px] text-white/85 md:text-sm">Program detaylarını izlemek için oynat butonuna tıklayın.</p>
            </div>
          </button>
          <div class="pointer-events-none absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-black/60 to-transparent"></div>
         
        </div>
      </div> -->
    </div>
  </section>
<!-- <div   class="w-full h-0.5 bg-gradient-to-r from-slate-200 to-slate-50"></div>  -->
  <section class="home-deferred-section w-full py-0 mt-0 mb-0">
  <div
    class="w-full mx-0 mt-2 border-none bg-gradient-to-r from-slate-200 to-slate-50 transform lg:-translate-y-2 flex flex-col  items-start justify-center rounded-lg  mt-3 md:mt-0"
  >
    <HomeNearestUmrahTours />
 
  </div>
</section>

      <LazyHomeHotelShowcase :hydrate-on-visible="{ rootMargin: '500px 0px' }" />

<section class="home-deferred-section home-decision-hub w-full border-y border-slate-200/80 px-4 py-12 sm:px-6 md:py-16">
  <div class="mx-auto max-w-screen-xl">
    <div class="grid gap-7 lg:grid-cols-[minmax(0,1.05fr)_minmax(340px,0.95fr)] lg:items-end lg:gap-12">
      <div>
        <span class="mb-4 inline-flex items-center gap-2 rounded-full border border-teal-200 bg-teal-50 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.16em] text-teal-800">
          <span class="h-1.5 w-1.5 rounded-full bg-amber-500"></span>
          {{ homeDecisionContent.eyebrow }}
        </span>
        <h1 class="mb-4 max-w-3xl text-3xl font-black leading-[1.08] tracking-tight text-slate-950 md:text-5xl">
          {{ umrahSeoStrategy.home.h1 }}
        </h1>
        <p class="mb-0 max-w-3xl text-base leading-8 text-slate-600 md:text-lg">
          {{ homeDecisionContent.intro }}
        </p>
      </div>

      <aside class="rounded-3xl border border-slate-200 bg-white p-5 shadow-[0_24px_56px_-40px_rgba(15,23,42,0.72)] md:p-6" :aria-label="homeDecisionContent.summaryLabel">
        <!-- <p class="mb-3 text-xs font-extrabold uppercase tracking-[.16em] text-amber-700">{{ homeDecisionContent.summaryEyebrow }}</p> -->
        <p class="mb-5 text-lg font-black leading-7 text-slate-900">{{ homeDecisionContent.summary }}</p>
        <ul class="grid gap-3 sm:grid-cols-3 lg:grid-cols-1" :aria-label="homeDecisionContent.summaryLabel">
          <li v-for="item in homeDecisionContent.proofPoints" :key="item.title" class="flex items-start gap-3 rounded-2xl bg-slate-50 p-3">
            <font-awesome-icon :icon="item.icon" class="mt-0.5 h-4 w-4 shrink-0 text-teal-700" />
            <span><strong class="block text-sm text-slate-900">{{ item.title }}</strong><span class="mt-0.5 block text-xs leading-5 text-slate-600">{{ item.text }}</span></span>
          </li>
        </ul>
      </aside>
    </div>

    <section class="mt-10 rounded-[2rem] border border-teal-200 bg-white p-5 shadow-[0_28px_64px_-44px_rgba(15,118,110,0.55)] md:p-8" aria-labelledby="home-decision-answer-heading">
      <div class="grid gap-6 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)] lg:items-center">
        <div>
          <p class="mb-2 text-xs font-extrabold uppercase tracking-[.16em] text-teal-700">{{ homeDecisionContent.answerEyebrow }}</p>
          <h2 id="home-decision-answer-heading" class="mb-3 text-2xl font-black leading-tight text-slate-950 md:text-3xl">{{ homeDecisionContent.answerHeading }}</h2>
          <p class="mb-0 text-sm leading-7 text-slate-600 md:text-base">{{ homeDecisionContent.answerText }}</p>
        </div>
        <ol class="grid gap-3 sm:grid-cols-3">
          <li v-for="(item, index) in homeDecisionContent.checklist" :key="item.title" class="rounded-2xl border border-slate-200 bg-slate-50 p-4">
            <span class="mb-4 flex h-8 w-8 items-center justify-center rounded-xl bg-teal-700 text-xs font-black text-white">0{{ index + 1 }}</span>
            <h3 class="mb-1 text-sm font-extrabold text-slate-900">{{ item.title }}</h3>
            <p class="mb-0 text-xs leading-5 text-slate-600">{{ item.text }}</p>
          </li>
        </ol>
      </div>
    </section>

    <section class="mt-10" aria-labelledby="home-program-types-heading">
      <div class="mb-5 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div>
          <p class="mb-2 text-xs font-extrabold uppercase tracking-[.16em] text-amber-700">{{ homeDecisionContent.programEyebrow }}</p>
          <h2 id="home-program-types-heading" class="mb-0 text-2xl font-black text-slate-950 md:text-3xl">{{ homeDecisionContent.programHeading }}</h2>
        </div>
        <a :href="getPath('/tour/umre-turlari')" class="inline-flex items-center gap-2 text-sm font-extrabold text-teal-800 hover:underline" @click.prevent.stop="goPath('/tour/umre-turlari')">{{ homeDecisionContent.allToursCta }} <span aria-hidden="true">→</span></a>
      </div>
      <div class="grid gap-4 md:grid-cols-3">
        <a v-for="item in homeDecisionContent.programs" :key="item.path" :href="getPath(item.path)" class="group relative overflow-hidden rounded-3xl border border-slate-200 bg-white p-5 shadow-sm transition hover:-translate-y-1 hover:border-teal-300 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-teal-600 focus:ring-offset-2" @click.prevent.stop="goPath(item.path)">
          <span class="mb-5 flex h-10 w-10 items-center justify-center rounded-2xl" :class="item.iconClass"><font-awesome-icon :icon="item.icon" class="h-4 w-4" /></span>
          <p class="mb-2 text-xs font-extrabold uppercase tracking-[.13em] text-slate-500">{{ item.eyebrow }}</p>
          <h3 class="mb-2 text-lg font-black text-slate-950">{{ item.title }}</h3>
          <p class="mb-5 text-sm leading-6 text-slate-600">{{ item.text }}</p>
          <span class="text-sm font-extrabold text-teal-800 group-hover:underline">{{ homeDecisionContent.programCta }} <span aria-hidden="true">→</span></span>
        </a>
      </div>
    </section>

    <details class="group mt-10 rounded-3xl border border-slate-200 bg-white p-5 md:p-6">
      <summary class="flex cursor-pointer list-none items-center justify-between gap-5 marker:hidden">
        <span><span class="mb-1 block text-xs font-extrabold uppercase tracking-[.16em] text-teal-700">{{ homeDecisionContent.guideEyebrow }}</span><span class="block text-lg font-black text-slate-950">{{ homeDecisionContent.guideHeading }}</span></span>
        <font-awesome-icon icon="fa-solid fa-chevron-down" class="h-4 w-4 shrink-0 text-teal-700 transition-transform duration-200 group-open:rotate-180" />
      </summary>
      <div class="mt-5 grid gap-4 border-t border-slate-100 pt-5 md:grid-cols-2">
        <article v-for="item in homeDecisionContent.guideItems" :key="item.title" class="rounded-2xl bg-slate-50 p-4">
          <h3 class="mb-1.5 text-sm font-extrabold text-slate-900">{{ item.title }}</h3>
          <p class="mb-0 text-sm leading-6 text-slate-600">{{ item.text }}</p>
        </article>
      </div>
      <a :href="getPath('/page/en-iyi-umre-turu-nasil-secilir')" class="mt-5 inline-flex text-sm font-extrabold text-teal-800 hover:underline" @click.prevent.stop="goPath('/page/en-iyi-umre-turu-nasil-secilir')">{{ homeDecisionContent.guideCta }} <span aria-hidden="true">→</span></a>
    </details>
  </div>
</section>
 
  <section class="home-deferred-section quick-access-modern max-w-screen-xl mx-auto px-4 py-2 grid grid-cols-1 md:grid-cols-5 gap-3 md:gap-4">
  <div class="col-span-2 rounded-3xl bg-gradient-to-b from-white to-neutral-100/70 p-2.5 md:p-3 shadow-[0_14px_24px_-20px_rgba(22,32,51,0.3)] ring-1 ring-neutral-200/70">
    <div class="mb-3 flex items-center justify-between">
      <span class="text-sm font-semibold text-neutral-900">{{ $t('Hızlı Erişim') }}</span>
      <span class="text-xs text-neutral-500">{{ !isMobile ? '6' : '5' }}</span>
    </div>

        <div class="grid grid-cols-1 xl:grid-cols-2 gap-2 md:gap-2.5">
      <a href="/tours/rota-balkan-turlari" target="_blank" @click.prevent.stop="goPath('/tours/rota-balkan-turlari')"
          class="quick-access-card group rounded-xl border border-slate-200 bg-white p-2.5 transition-all duration-300 hover:-translate-y-0.5 hover:border-brand-300 hover:shadow-[0_12px_20px_-16px_rgba(22,32,51,0.42)]">
        <div class="flex items-start gap-3">
          <span class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-brand-700 to-brand-900 text-xs font-bold text-white">BT</span>
          <div class="min-w-0">
            <p class="text-sm font-semibold text-neutral-900 leading-5 mb-0">{{ $t('Balkan Turları') }}</p>
            <p class="quick-access-desc text-xs text-neutral-600 leading-4">{{ locale == 'tr' ? 'Yeni sezon rotaları ve tarihleri' : 'New season routes and dates' }}</p>
          </div>
        </div>
      </a>

      <a href="/user/quiz/quiz-all" target="_blank" @click.prevent.stop="goPath('/user/quiz/quiz-all')"
        class="quick-access-card group rounded-xl border border-slate-200  bg-white p-2.5 transition-all duration-300 hover:-translate-y-0.5 hover:border-accent-300 hover:shadow-[0_12px_20px_-16px_rgba(147,98,18,0.42)]">
        <div class="flex items-start gap-3">
          <span class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-accent-500 to-accent-600 text-xs font-bold text-white">QZ</span>
          <div class="min-w-0">
            <p class="text-sm font-semibold text-neutral-900 leading-5 mb-0">{{ $t('Umre Bilgi Testi') }}</p>
            <p class="quick-access-desc text-xs text-neutral-600 leading-4">{{ locale == 'tr' ? 'Bilginizi kısa testlerle ölçün' : 'Measure your knowledge quickly' }}</p>
          </div>
        </div>
      </a>

      <a :href="getPath('/page/umre-rehberi')" @click.stop.prevent="goPath('/page/umre-rehberi')" target="_blank"
        class="quick-access-card group rounded-xl border border-slate-200  bg-white p-2.5 transition-all duration-300 hover:-translate-y-0.5 hover:border-support-300 hover:shadow-[0_12px_20px_-16px_rgba(15,118,110,0.42)]">
        <div class="flex items-start gap-3">
          <span class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-support-500 to-support-700 text-xs font-bold text-white">UR</span>
          <div class="min-w-0">
            <p class="text-sm font-semibold text-neutral-900 leading-5 mb-0">{{ $t('Umre Rehberi') }}</p>
            <p class="quick-access-desc text-xs text-neutral-600 leading-4">{{ locale == 'tr' ? 'Adım adım ibadet ve hazırlık' : 'Step-by-step preparation guide' }}</p>
          </div>
        </div>
      </a>

      <a :href="getPath('/page/umre-ve-hac-rehberi')" @click.stop.prevent="goPath('/page/umre-ve-hac-rehberi')" target="_blank"
        class="quick-access-card group rounded-xl border border-slate-200  bg-white p-2.5 transition-all duration-300 hover:-translate-y-0.5 hover:border-brand-300 hover:shadow-[0_12px_20px_-16px_rgba(22,32,51,0.42)]">
        <div class="flex items-start gap-3">
          <span class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-brand-600 to-brand-800 text-xs font-bold text-white">UH</span>
          <div class="min-w-0">
            <p class="text-sm font-semibold text-neutral-900 leading-5 mb-0">{{ locale == 'tr' ? 'Umre & Hac Rehberi' : 'Umrah & Hajj Guide' }}</p>
            <p class="quick-access-desc text-xs text-neutral-600 leading-4">{{ locale == 'tr' ? 'Temel bilgiler ve hazırlık notları' : 'Core information and preparation notes' }}</p>
          </div>
        </div>
      </a>

      <a :href="getPath('/tour/kisiye-ozel-umre-turlari')" @click.stop.prevent="goPath('/tour/kisiye-ozel-umre-turlari')" target="_blank"
        class="quick-access-card group rounded-xl border border-slate-200  bg-white p-2.5 transition-all duration-300 hover:-translate-y-0.5 hover:border-support-300 hover:shadow-[0_12px_20px_-16px_rgba(15,118,110,0.42)]">
        <div class="flex items-start gap-3">
          <span class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-support-600 to-support-700 text-xs font-bold text-white">OU</span>
          <div class="min-w-0">
            <p class="text-sm font-semibold text-neutral-900 leading-5 mb-0">{{ $t('Özel Umre Turları') }}</p>
            <p class="quick-access-desc text-xs text-neutral-600 leading-4">{{ locale == 'tr' ? 'Size özel planlanan programlar' : 'Tailor-made tour plans' }}</p>
          </div>
        </div>
      </a>

      <a v-if="!isMobile" :href="getPath('/page/hac')" @click.prevent.stop="goPath('/page/hac')" target="_blank"
        class="quick-access-card group rounded-xl border border-slate-200  bg-white p-2.5 transition-all duration-300 hover:-translate-y-0.5 hover:border-accent-300 hover:shadow-[0_12px_20px_-16px_rgba(147,98,18,0.42)]">
        <div class="flex items-start gap-3">
          <span class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-accent-500 to-accent-600 text-xs font-bold text-white">HC</span>
          <div class="min-w-0">
            <p class="text-sm font-semibold text-neutral-900 leading-5 mb-0">{{ $t('Hac Turları') }}</p>
            <p class="quick-access-desc text-xs text-neutral-600 leading-4">{{ locale == 'tr' ? 'Kontenjan ve dönem detayları' : 'Season and quota details' }}</p>
          </div>
        </div>
      </a>
    </div>
  </div>

  <div class="col-span-3 rounded-3xl bg-white p-3.5 md:p-4.5 shadow-[0_14px_24px_-20px_rgba(22,32,51,0.3)] ring-1 ring-neutral-200/70">
    <div class="mb-3 flex items-center justify-between">
      <span class="font-semibold text-sm text-neutral-900">{{ $t('Popüler Konular') }}</span>
      <span class="inline-flex h-6 min-w-6 items-center justify-center rounded-full bg-neutral-100 px-2 text-xs text-neutral-600">{{ blogs?.length || 0 }}</span>
    </div>
    <div class="flex flex-col gap-1.5">
      <template v-for="(blg, i) in blogs" :key="'blg_'+i">
        <a :href="getPath('/page/'+blg.blog_Link)"
           class="group flex items-start gap-2.5 rounded-xl border border-transparent p-2.5 transition-all duration-300 hover:border-neutral-300 hover:bg-neutral-100">
          <span class="mt-0.5 inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand-700 transition-all duration-300 group-hover:bg-brand-700 group-hover:text-white">
            <font-awesome-icon icon="fa-solid fa-chevron-right" class="h-3 w-3"></font-awesome-icon>
          </span>
          <div class="min-w-0">
            <div class="text-[13px] font-semibold text-neutral-900" v-html="blg.blog_Title"></div>
            <div class="text-[12px] text-neutral-600 line-clamp-2" v-html="blg.blog_Stext"></div>
          </div>
        </a>
      </template>
    </div>
  </div>
</section>
 


    <!-- <section
      class="max-w-screen-xl overflow-x-hidden mx-2 sm:mx-auto px-4 sm:px-6 lg:px-0  py-0   rounded-2xl  md:rounded-[3rem] bg-white  ">
      <Instagram></Instagram>
    </section> -->
    <section class="home-deferred-section why-choose-us-section why-premium-wrap pt-20 md:pt-28 pb-10 md:pb-16 lg:pb-20 lg:-mt-8 relative overflow-hidden">
      <div class="why-premium-backdrop absolute inset-0"></div>
      <div class="why-premium-orb why-premium-orb-a absolute -top-10 -left-10 h-36 w-36 rounded-full bg-accent-200/45 blur-3xl"></div>
      <div class="why-premium-orb why-premium-orb-b absolute bottom-0 right-0 h-44 w-44 rounded-full bg-support-200/45 blur-3xl"></div>

      <div class="container relative">
        <div class="text-center mb-7 md:mb-12">
          <span class="why-premium-reveal why-premium-kicker inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-xs md:text-sm font-semibold text-accent-700 mb-4">
            <span class="why-premium-kicker-mark" aria-hidden="true"></span>
            {{ $t('Özel Hizmet Anlayışı') }}
          </span>
          <h3 class="why-premium-reveal text-2xl md:text-4xl font-semibold tracking-tight text-neutral-900">{{ $t('Umrede 5 Yıldızlı Hizmet') }}</h3>
          <p class="why-premium-reveal max-w-[620px] mx-auto mt-3 text-sm md:text-base leading-relaxed text-neutral-600 font-1">{{ $t('Tercih Edilmemizin Çok Sebebi Var!') }}</p>
        </div>

        <div v-if="!isMobile" class="why-premium-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-stretch gap-4 md:gap-5">
          <div class="why-premium-card why-tone-brand group">
            <div class="why-premium-card-head">
              <div class="why-premium-icon-shell">
                <img src="/assets/img/temp/world-tour-icon.svg" loading="lazy" alt="world-tour-icon" style="width:58px;height:61px;" />
              </div>
              <span class="why-premium-index" aria-hidden="true">01</span>
            </div>
            <div class="why-premium-content">
              <h4>{{ $t("HomeInfoTitle1") }}</h4>
              <p>{{ $t("HomeInfoText1") }}</p>
            </div>
            <span class="why-premium-line" aria-hidden="true"></span>
          </div>

          <div class="why-premium-card why-tone-support group">
            <div class="why-premium-card-head">
              <div class="why-premium-icon-shell">
                <img src="/assets/img/temp/travelling-icon.svg" loading="lazy" alt="travelling-tour-icon" style="width:61px;height:54px;" />
              </div>
              <span class="why-premium-index" aria-hidden="true">02</span>
            </div>
            <div class="why-premium-content">
              <h4>{{ $t("HomeInfoTitle2") }}</h4>
              <p>{{ $t("HomeInfoText2") }}</p>
            </div>
            <span class="why-premium-line" aria-hidden="true"></span>
          </div>

          <div class="why-premium-card why-tone-accent group">
            <div class="why-premium-card-head">
              <div class="why-premium-icon-shell">
                <img src="/assets/img/temp/best-guide-icon.svg" alt="best-tour-icon" loading="lazy" style="width:65px;height:65px;" />
              </div>
              <span class="why-premium-index" aria-hidden="true">03</span>
            </div>
            <div class="why-premium-content">
              <h4>{{ $t("HomeInfoTitle3") }}</h4>
              <p>{{ $t("HomeInfoText3") }}</p>
            </div>
            <span class="why-premium-line" aria-hidden="true"></span>
          </div>

          <div class="why-premium-card why-tone-support group">
            <div class="why-premium-card-head">
              <div class="why-premium-icon-shell">
                <img src="/assets/img/temp/support-icon.svg" alt="support-tour-icon" loading="lazy" style="width:56px;height:56px;" />
              </div>
              <span class="why-premium-index" aria-hidden="true">04</span>
            </div>
            <div class="why-premium-content">
              <h4>{{ $t("HomeInfoTitle4") }}</h4>
              <p>{{ $t("HomeInfoText4") }}</p>
            </div>
            <span class="why-premium-line" aria-hidden="true"></span>
          </div>

          <div class="why-premium-card why-tone-accent group">
            <div class="why-premium-card-head">
              <div class="why-premium-icon-shell">
                <img src="/assets/img/temp/luxary-hotel-icon.svg" loading="lazy" alt="luxary-tour-icon" style="width:57px;height:57px;" />
              </div>
              <span class="why-premium-index" aria-hidden="true">05</span>
            </div>
            <div class="why-premium-content">
              <h4>{{ $t("HomeInfoTitle5") }}</h4>
              <p>{{ $t("HomeInfoText5") }}</p>
            </div>
            <span class="why-premium-line" aria-hidden="true"></span>
          </div>

          <div class="why-premium-card why-tone-brand group">
            <div class="why-premium-card-head">
              <div class="why-premium-icon-shell">
                <img src="/assets/img/temp/easy-booking-icon.svg" loading="lazy" alt="easy-tour-icon" style="width:57px;height:57px;" />
              </div>
              <span class="why-premium-index" aria-hidden="true">06</span>
            </div>
            <div class="why-premium-content">
              <h4>{{ $t("HomeInfoTitle6") }}</h4>
              <p>{{ $t("HomeInfoText6") }}</p>
            </div>
            <span class="why-premium-line" aria-hidden="true"></span>
          </div>
        </div>

        <div v-if="isMobile">
          <Carousel class="p-0 m-0" :itemsToShow="1.1" v-model="currentSlideInacturFark" :wrapAround="true" :transition="500">
            <Slide class="swiper-slide p-2 w-full group flex flex-col">
              <div class="why-premium-mobile-card why-tone-brand rounded-3xl border border-neutral-300 bg-white/95 p-3.5 flex items-center gap-4 shadow-[0_12px_24px_-18px_rgba(22,32,51,0.45)]">
                <div class="rounded-2xl w-16 h-16 flex items-center justify-center shrink-0 bg-gradient-to-br from-brand-100 to-brand-200/70">
                  <img src="/assets/img/temp/world-tour-icon.svg" loading="lazy" alt="world-tour-icon" style="width:46px;height:49px;" />
                </div>
                <div>
                  <span class="text-base font-semibold text-neutral-900 mb-1 block">{{ $t("HomeInfoTitle1") }}</span>
                  <p class="text-sm text-neutral-600 mb-0">{{ $t("HomeInfoText1") }}</p>
                </div>
              </div>
            </Slide>

            <Slide class="swiper-slide p-2 w-full group flex flex-col">
              <div class="why-premium-mobile-card why-tone-support rounded-3xl border border-neutral-300 bg-white/95 p-3.5 flex items-center gap-4 shadow-[0_12px_24px_-18px_rgba(15,118,110,0.45)]">
                <div class="rounded-2xl w-16 h-16 flex items-center justify-center shrink-0 bg-gradient-to-br from-support-100 to-support-200/70">
                  <img src="/assets/img/temp/travelling-icon.svg" loading="lazy" alt="travelling-tour-icon" style="width:49px;height:44px;" />
                </div>
                <div>
                  <span class="text-base font-semibold text-neutral-900 mb-1 block">{{ $t("HomeInfoTitle2") }}</span>
                  <p class="text-sm text-neutral-600 mb-0">{{ $t("HomeInfoText2") }}</p>
                </div>
              </div>
            </Slide>

            <Slide class="swiper-slide p-2 w-full group flex flex-col">
              <div class="why-premium-mobile-card why-tone-accent rounded-3xl border border-neutral-300 bg-white/95 p-3.5 flex items-center gap-4 shadow-[0_12px_24px_-18px_rgba(147,98,18,0.5)]">
                <div class="rounded-2xl w-16 h-16 flex items-center justify-center shrink-0 bg-gradient-to-br from-accent-100 to-accent-200/70">
                  <img src="/assets/img/temp/best-guide-icon.svg" loading="lazy" alt="best-tour-icon" style="width:50px;height:50px;" />
                </div>
                <div>
                  <span class="text-base font-semibold text-neutral-900 mb-1 block">{{ $t("HomeInfoTitle3") }}</span>
                  <p class="text-sm text-neutral-600 mb-0">{{ $t("HomeInfoText3") }}</p>
                </div>
              </div>
            </Slide>

            <Slide class="swiper-slide p-2 w-full group flex flex-col">
              <div class="why-premium-mobile-card why-tone-support rounded-3xl border border-neutral-300 bg-white/95 p-3.5 flex items-center gap-4 shadow-[0_12px_24px_-18px_rgba(15,118,110,0.45)]">
                <div class="rounded-2xl w-16 h-16 flex items-center justify-center shrink-0 bg-gradient-to-br from-support-100 to-support-200/70">
                  <img src="/assets/img/temp/support-icon.svg" loading="lazy" alt="support-tour-icon" style="width:42px;height:42px;" />
                </div>
                <div>
                  <span class="text-base font-semibold text-neutral-900 mb-1 block">{{ $t("HomeInfoTitle4") }}</span>
                  <p class="text-sm text-neutral-600 mb-0">{{ $t("HomeInfoText4") }}</p>
                </div>
              </div>
            </Slide>

            <Slide class="swiper-slide p-2 w-full group flex flex-col">
              <div class="why-premium-mobile-card why-tone-accent rounded-3xl border border-neutral-300 bg-white/95 p-3.5 flex items-center gap-4 shadow-[0_12px_24px_-18px_rgba(147,98,18,0.5)]">
                <div class="rounded-2xl w-16 h-16 flex items-center justify-center shrink-0 bg-gradient-to-br from-accent-100 to-accent-200/70">
                  <img src="/assets/img/temp/luxary-hotel-icon.svg" loading="lazy" alt="luxary-tour-icon" style="width:44px;height:44px;" />
                </div>
                <div>
                  <span class="text-base font-semibold text-neutral-900 mb-1 block">{{ $t("HomeInfoTitle5") }}</span>
                  <p class="text-sm text-neutral-600 mb-0">{{ $t("HomeInfoText5") }}</p>
                </div>
              </div>
            </Slide>

            <Slide class="swiper-slide p-2 w-full group flex flex-col">
              <div class="why-premium-mobile-card why-tone-brand rounded-3xl border border-neutral-300 bg-white/95 p-3.5 flex items-center gap-4 shadow-[0_12px_24px_-18px_rgba(22,32,51,0.45)]">
                <div class="rounded-2xl w-16 h-16 flex items-center justify-center shrink-0 bg-gradient-to-br from-brand-100 to-brand-200/70">
                  <img src="/assets/img/temp/easy-booking-icon.svg" loading="lazy" alt="easy-tour-icon" style="width:44px;height:44px;" />
                </div>
                <div>
                  <span class="text-base font-semibold text-neutral-900 mb-1 block">{{ $t("HomeInfoTitle6") }}</span>
                  <p class="text-sm text-neutral-600 mb-0">{{ $t("HomeInfoText6") }}</p>
                </div>
              </div>
            </Slide>
          </Carousel>
        </div>


      </div>
    </section>




    <section class="home-deferred-section why-inanc-wrappx-3 sm:px-5 lg:px-0 py-10 md:py-14">
      <div class="relative overflow-hidden bg-gradient-to-br from-brand-900 via-brand-800 to-support-700 text-white  ">
       <div class=" max-w-screen-xl  mx-auto "> <div class="absolute -top-16 -left-16 h-44 w-44 rounded-full bg-accent-300/25 blur-3xl"></div>
        <div class="absolute -bottom-12 right-0 h-40 w-40 rounded-full bg-support-300/30 blur-3xl"></div>

        <div class="relative grid grid-cols-1 xl:grid-cols-12 gap-6 p-4 sm:p-6 md:p-8 lg:p-10">
          <div class="xl:col-span-4">
            <span class="inline-flex items-center rounded-full border border-accent-300/70 bg-accent-500/20 px-3 py-1 text-xs font-semibold text-accent-100">
              {{ pageCopy.whyBadge }}
            </span>
            <h2 class="mt-3 text-2xl md:text-4xl font-semibold leading-tight text-white">
              {{ pageCopy.whyHeading }}
              <span class="text-accent-200">{{ pageCopy.whyHeadingAccent }}</span>
            </h2>
            <p class="mt-3 text-sm md:text-base text-neutral-100/95 max-w-[46ch]">
              {{ pageCopy.whyDescription }}
            </p>

            <!-- <div class="mt-5 rounded-2xl border border-white/15 bg-white/5 backdrop-blur-sm p-3">
              <p class="text-xs uppercase tracking-[0.15em] text-accent-100/95 mb-2">Büyük Vektör Alanı</p>
              <div class="why-inanc-illustration relative rounded-xl border border-dashed border-white/30 bg-white/5 min-h-[220px] flex items-center justify-center overflow-hidden">
                <div class="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
                <div class="relative z-10 text-center px-4">
                  <span class="block text-sm font-semibold text-white">{{ activeWhyReason.title }} için vektör görsel</span>
                  <span class="block text-xs text-neutral-100/80 mt-1">Bu alana 1400x1100 oranında SVG/WEBP eklenebilir</span>
                </div>
              </div>
            </div> -->
          </div>

          <div class="xl:col-span-8">
            <div class="grid grid-cols-2 md:grid-cols-4 gap-2">
              <button
                v-for="item in whyReasons"
                :key="item.key"
                @click="activeWhyTab = item.key"
                class="why-tab-btn rounded-xl px-3 py-2.5 text-left transition-all duration-300 border"
                :class="activeWhyTab === item.key ? 'border-accent-200 bg-accent-500/25 text-white shadow-[0_12px_22px_-16px_rgba(180,122,22,0.7)]' : 'border-white/20 bg-white/5 text-neutral-100 hover:bg-white/10'"
              >
                <span class="block text-xs text-neutral-100/75">0{{ item.order }}</span>
                <span class="block text-sm font-semibold leading-5">{{ item.tab }}</span>
              </button>
            </div>

            <div class="mt-3 rounded-2xl border border-white/15 bg-white/5 backdrop-blur-sm p-4 md:p-5">
              <div class="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5">
                <div class="lg:col-span-7">
                  <h3 class="text-xl md:text-2xl font-semibold text-white">{{ activeWhyReason.title }}</h3>
                  <p class="mt-2 text-sm md:text-base text-neutral-100/95">{{ activeWhyReason.description }}</p>

                  <ul class="mt-4 space-y-2">
                    <li v-for="bullet in activeWhyReason.bullets" :key="bullet" class="flex items-start gap-2 text-sm md:text-base text-neutral-100">
                      <font-awesome-icon icon="fa-solid fa-check" class="mt-1 h-3.5 w-3.5 text-accent-200"></font-awesome-icon>
                      <span>{{ bullet }}</span>
                    </li>
                  </ul>

                  <a :href="getPath('/contact')" @click.prevent.stop="goPath('/contact')" class="mt-5 inline-flex items-center rounded-xl bg-accent-700 px-4 py-2 text-sm font-semibold text-white hover:bg-accent-800 transition">
                    {{ pageCopy.getDetails }}
                  </a>
                </div>

                <div class="lg:col-span-5">
                  <div class="h-full rounded-xl">
                    <!-- <p class="text-xs uppercase tracking-[0.14em] text-accent-100 mb-2">AI Görsel Promptu</p> -->
                    <img :src="activeWhyReason.img" loading="lazy" alt="AI prompt illustration" class="rounded-lg border border-white/10">
                    <!-- <div class="rounded-lg bg-brand-900/50 border border-white/10 p-3 max-h-[220px] overflow-auto">
                      <p class="text-[12px] leading-5 text-neutral-100/95 whitespace-pre-line">{{ activeWhyReason.prompt }}</p>
                    </div> -->
                    <!-- <p class="mt-2 text-[11px] text-neutral-200/80">
                      Not: Bu prompt ile üretilen görselde insanlar modern, saygılı ve sade bir stilde olabilir; metinsiz görsel tercih edin.
                    </p> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </section>

    <section class="home-deferred-section w-full my-4 py-0">
      <BaseSection>
        <div class="col-span-12 lg:col-span-6" v-if="!isMobile">
          <div class="w-full">
            <!-- <iframe loading=“lazy” src="https://www.youtube.com/embed/e1qOAkVum18?modestbranding=1&autoplay=1"
              width="100%" height="500"
              srcdoc="<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/e1qOAkVum18?autoplay=1><img src=https://img.youtube.com/vi/e1qOAkVum18/hqdefault.jpg alt='Video The Dark Knight Rises: What Went Wrong? – Wisecrack Edition'><span>▶</span></a>"
              frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen title="İnanç Tur Umre Programından Kesitler">
            </iframe> -->
          </div>
        </div>
        <div class="col-span-12 lg:col-span-12 px-4 sm:px-6 mt-8">
          <span class="text-base text-support-700 font-semibold uppercase mb-4 sm:mb-2">{{ $t('Destek') }}</span>
          <span class="block text-xl sm:text-xl font-semibold text-neutral-900 mb-10 sm:mb-6">
            {{ $t('Sıkça Sorulan Sorular') }}
          </span>

          <ul class="shadow-box" v-if="accordions">
            <BaseAccordion v-for="(accordion, index) in accordions[locale]" :key="index" :accordion="accordion" />
          </ul>
          <div class="mt-5 flex justify-center">
            <a
              :href="getPath('/page/faq')"
              class="inline-flex items-center gap-2 rounded-xl border border-teal-200 bg-teal-50 px-5 py-3 text-sm font-bold text-teal-800 transition hover:border-teal-300 hover:bg-teal-100"
              @click.prevent="goPath('/page/faq')"
            >
              {{ locale === 'en' ? 'View all frequently asked questions' : 'Tüm sıkça sorulan soruları görüntüle' }}
              <font-awesome-icon icon="fa-solid fa-arrow-right" class="h-3 w-3" />
            </a>
          </div>
        </div>
      </BaseSection>
    </section>
</section>
    <div class="w-full my-10 flex justify-center">
      <a href="#navbar"
        class="px-6 py-3 flex items-center space-x-2 bg-neutral-50 hover:bg-neutral-100 hover:shadow-md border border-neutral-300 rounded-md text-neutral-700">
        <span>{{ $t('Başa Dön') }}</span>
        <ArrowUpIcon :size="20" />
      </a>
    </div>

    <div v-if="1 == 2" class="hidden central-menu-tr central-menu-en"></div>



  </div>
</template>

<script>
export default {
  name: 'IndexPage',
  data() {
    return {
      selected: 0,
    }
  }
}
</script>

<style scoped>
.home-decision-hub {
  position: relative;
  overflow: hidden;
  background:
    radial-gradient(circle at 88% 8%, rgba(180, 122, 22, 0.12), transparent 24rem),
    radial-gradient(circle at 7% 82%, rgba(15, 118, 110, 0.1), transparent 26rem),
    linear-gradient(145deg, #f8fafc 0%, #ffffff 46%, #f8fafc 100%);
}

.home-decision-hub::before {
  position: absolute;
  inset: 0;
  content: '';
  opacity: 0.32;
  background-image: radial-gradient(rgba(36, 57, 93, 0.13) 0.65px, transparent 0.65px);
  background-size: 22px 22px;
  mask-image: linear-gradient(90deg, transparent, #000 18%, #000 82%, transparent);
  pointer-events: none;
}

.home-decision-hub > div {
  position: relative;
}

.hero-sheen {
  position: relative;
  isolation: isolate;
  width: 100%;
}

.hero-sheen::before {
  content: '';
  position: absolute;
  inset: -18% -55%;
  z-index: 0;
  background: linear-gradient(115deg, rgba(255, 255, 255, 0) 35%, rgba(255, 255, 255, 0.34) 50%, rgba(255, 255, 255, 0) 65%);
  transform: translateX(-62%) skewX(-14deg);
  animation: heroSheen 7.8s ease-in-out infinite;
  pointer-events: none;
}

.hero-sheen > :not([class*='absolute']) {
  position: relative;
  z-index: 1;
}

.home-program-card {
  --program-tone: #0f766e;
  --program-soft: rgba(15, 118, 110, 0.1);
  --program-border: rgba(15, 118, 110, 0.24);
  position: relative;
  isolation: isolate;
  display: flex;
  min-height: 224px;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--program-border);
  border-radius: 1.25rem;
  padding: 1.15rem;
  background:
    radial-gradient(circle at 100% 0%, var(--program-soft), transparent 34%),
    linear-gradient(145deg, #ffffff 0%, #fbfcfc 100%);
  box-shadow: 0 18px 34px -28px rgba(15, 31, 49, 0.58);
  color: #172033;
  text-decoration: none;
  transition: transform 220ms ease, border-color 220ms ease, box-shadow 220ms ease;
}

.home-program-card:hover {
  transform: translateY(-4px);
  border-color: color-mix(in srgb, var(--program-tone) 48%, white);
  box-shadow: 0 26px 42px -28px rgba(15, 31, 49, 0.58);
}

.home-program-card:focus-visible {
  outline: 3px solid color-mix(in srgb, var(--program-tone) 55%, white);
  outline-offset: 3px;
}

.home-program-card--gold {
  --program-tone: #aa751f;
  --program-soft: rgba(190, 139, 46, 0.14);
  --program-border: rgba(190, 139, 46, 0.31);
}

.home-program-card--navy {
  --program-tone: #294d72;
  --program-soft: rgba(41, 77, 114, 0.11);
  --program-border: rgba(41, 77, 114, 0.24);
}

.home-program-card--teal-muted {
  --program-tone: #2f786f;
  --program-soft: rgba(47, 120, 111, 0.09);
  --program-border: rgba(47, 120, 111, 0.24);
}

.home-program-card__accent {
  position: absolute;
  top: 0;
  right: 1.15rem;
  left: 1.15rem;
  height: 3px;
  border-radius: 0 0 999px 999px;
  background: linear-gradient(90deg, transparent, var(--program-tone), transparent);
  opacity: 0.88;
}

.home-program-card__icon {
  display: inline-flex;
  width: 2.4rem;
  height: 2.4rem;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--program-border);
  border-radius: 0.82rem;
  background: var(--program-soft);
  color: var(--program-tone);
}

.home-program-card__badge,
.home-program-card__eyebrow {
  color: var(--program-tone);
  font-size: 0.65rem;
  font-weight: 800;
  line-height: 1.35;
  letter-spacing: 0.11em;
  text-transform: uppercase;
}

.home-program-card__badge {
  border: 1px solid var(--program-border);
  border-radius: 999px;
  padding: 0.3rem 0.55rem;
  background: rgba(255, 255, 255, 0.74);
  letter-spacing: 0.04em;
  text-transform: none;
}

.home-program-card__eyebrow { margin: 0 0 0.35rem; }

.home-program-card__title {
  margin: 0;
  color: #122136;
  font-size: clamp(1.15rem, 1.3vw, 1.38rem);
  font-weight: 750;
  line-height: 1.18;
  letter-spacing: -0.025em;
}

.home-program-card__subtitle {
  min-height: 2.5em;
  margin: 0.38rem 0 0;
  color: #5f6c7d;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1.45;
}

.home-program-card__features {
  display: grid;
  gap: 0.38rem;
  margin: 0.75rem 0 0;
  padding: 0;
  color: #3d4b5c;
  font-size: 0.7rem;
  line-height: 1.35;
  list-style: none;
}

.home-program-card__features li {
  display: flex;
  align-items: flex-start;
  gap: 0.42rem;
}

.home-program-card__features svg {
  width: 0.65rem;
  height: 0.65rem;
  flex: none;
  margin-top: 0.13rem;
  color: var(--program-tone);
}

.home-program-card__cta {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  margin-top: auto;
  padding-top: 0.9rem;
  color: var(--program-tone);
  font-size: 0.74rem;
  font-weight: 800;
}

.home-program-card__cta svg { transition: transform 180ms ease; }
.home-program-card:hover .home-program-card__cta svg { transform: translateX(3px); }

.home-program-card--mobile { min-height: 220px; }

.why-inanc-wrap .why-tab-btn {
  transform: translateY(0);
}

.why-inanc-wrap .why-tab-btn:hover {
  transform: translateY(-1px);
}

.why-inanc-wrap .why-inanc-illustration::after {
  content: '';
  position: absolute;
  inset: auto -18% -35% auto;
  width: 170px;
  height: 170px;
  border-radius: 9999px;
  background: radial-gradient(circle, rgba(180,122,22,0.45) 0%, rgba(180,122,22,0.02) 72%);
  pointer-events: none;
}

.why-premium-orb {
  animation: whyFloat 7s ease-in-out infinite;
}

.why-premium-backdrop {
  background:
    radial-gradient(circle at 8% 18%, rgba(180, 122, 22, 0.08), transparent 26%),
    radial-gradient(circle at 92% 78%, rgba(15, 118, 110, 0.08), transparent 28%),
    linear-gradient(180deg, #ffffff 0%, #f8fafc 48%, #ffffff 100%);
}

.why-premium-backdrop::after {
  content: '';
  position: absolute;
  inset: 0;
  opacity: 0.42;
  background-image: radial-gradient(rgba(36, 57, 93, 0.14) 0.7px, transparent 0.7px);
  background-size: 20px 20px;
  mask-image: linear-gradient(to bottom, transparent, #000 28%, #000 72%, transparent);
  pointer-events: none;
}

.why-premium-kicker {
  border: 1px solid rgba(225, 185, 104, 0.65);
  background: rgba(252, 247, 236, 0.88);
  box-shadow: 0 8px 24px -18px rgba(116, 76, 16, 0.7);
  backdrop-filter: blur(8px);
}

.why-premium-kicker-mark {
  width: 7px;
  height: 7px;
  border-radius: 2px;
  background: #b47a16;
  box-shadow: 0 0 0 4px rgba(225, 185, 104, 0.2);
  transform: rotate(45deg);
}

.quick-access-modern .quick-access-desc {
  margin-bottom: 0;
}

.why-premium-orb-b {
  animation-delay: 1.2s;
}

.why-premium-reveal {
  animation: whyFadeUp 700ms ease both;
}

.why-premium-reveal:nth-of-type(2) {
  animation-delay: 120ms;
}

.why-premium-reveal:nth-of-type(3) {
  animation-delay: 220ms;
}

.why-premium-grid > .why-premium-card {
  --tone: #2f4773;
  --tone-soft: rgba(220, 228, 240, 0.72);
  --tone-glow: rgba(63, 93, 141, 0.16);
  position: relative;
  overflow: hidden;
  display: flex;
  min-height: 250px;
  flex-direction: column;
  padding: 1.5rem;
  border: 1px solid rgba(217, 225, 234, 0.9);
  border-radius: 1.5rem;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 18px 50px -34px rgba(22, 32, 51, 0.55);
  backdrop-filter: blur(12px);
  opacity: 0;
  animation: whyFadeUp 650ms ease forwards;
  transition: transform 320ms ease, border-color 320ms ease, box-shadow 320ms ease;
}

.why-premium-grid > .why-tone-support {
  --tone: #0f766e;
  --tone-soft: rgba(213, 241, 236, 0.74);
  --tone-glow: rgba(33, 145, 132, 0.16);
}

.why-premium-grid > .why-tone-accent {
  --tone: #936212;
  --tone-soft: rgba(247, 235, 208, 0.8);
  --tone-glow: rgba(180, 122, 22, 0.17);
}

.why-premium-grid > .why-premium-card::before {
  content: '';
  position: absolute;
  inset: 0 0 auto;
  height: 3px;
  background: linear-gradient(90deg, var(--tone), transparent 72%);
  opacity: 0.82;
  pointer-events: none;
}

.why-premium-grid > .why-premium-card::after {
  content: '';
  position: absolute;
  width: 160px;
  height: 160px;
  right: -85px;
  bottom: -100px;
  border-radius: 999px;
  background: var(--tone-glow);
  filter: blur(2px);
  transition: transform 450ms ease;
  pointer-events: none;
}

.why-premium-grid > .why-premium-card:hover {
  transform: translateY(-6px);
  border-color: color-mix(in srgb, var(--tone) 32%, white);
  box-shadow: 0 28px 60px -34px rgba(22, 32, 51, 0.62);
}

.why-premium-grid > .why-premium-card:hover::after {
  transform: scale(1.35);
}

.why-premium-card-head {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 1.25rem;
}

.why-premium-icon-shell {
  display: flex;
  width: 78px;
  height: 78px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.92);
  border-radius: 1.25rem;
  background: linear-gradient(145deg, #fff, var(--tone-soft));
  box-shadow: 0 16px 28px -20px var(--tone), inset 0 1px 0 #fff;
  transition: transform 320ms ease, box-shadow 320ms ease;
}

.why-premium-card:hover .why-premium-icon-shell {
  transform: translateY(-2px) rotate(-2deg);
  box-shadow: 0 20px 32px -20px var(--tone), inset 0 1px 0 #fff;
}

.why-premium-index {
  color: rgba(120, 135, 154, 0.34);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.14em;
}

.why-premium-content {
  position: relative;
  z-index: 1;
}

.why-premium-content h4 {
  margin: 0 0 0.5rem;
  color: #111827;
  font-size: 1.05rem;
  font-weight: 650;
  line-height: 1.35;
}

.why-premium-content p {
  margin: 0;
  color: #4b5563;
  font-size: 0.82rem;
  line-height: 1.7;
}

.why-premium-line {
  position: relative;
  z-index: 1;
  display: block;
  width: 32px;
  height: 2px;
  margin-top: auto;
  padding-top: 1.25rem;
  border-bottom: 2px solid var(--tone);
  opacity: 0.75;
  transition: width 320ms ease;
}

.why-premium-card:hover .why-premium-line {
  width: 54px;
}

.why-premium-grid > .why-premium-card:nth-child(1) { animation-delay: 40ms; }
.why-premium-grid > .why-premium-card:nth-child(2) { animation-delay: 110ms; }
.why-premium-grid > .why-premium-card:nth-child(3) { animation-delay: 180ms; }
.why-premium-grid > .why-premium-card:nth-child(4) { animation-delay: 250ms; }
.why-premium-grid > .why-premium-card:nth-child(5) { animation-delay: 320ms; }
.why-premium-grid > .why-premium-card:nth-child(6) { animation-delay: 390ms; }

.why-premium-mobile-card {
  position: relative;
  min-height: 108px;
  overflow: hidden;
  border-color: rgba(217, 225, 234, 0.9) !important;
  box-shadow: 0 18px 38px -28px rgba(22, 32, 51, 0.65) !important;
  backdrop-filter: blur(10px);
  animation: whyFadeUp 420ms ease both;
}

.why-premium-mobile-card::before {
  content: '';
  position: absolute;
  inset: 0 auto 0 0;
  width: 3px;
  background: #2f4773;
}

.why-premium-mobile-card.why-tone-support::before {
  background: #0f766e;
}

.why-premium-mobile-card.why-tone-accent::before {
  background: #b47a16;
}

.why-premium-mobile-card > div:first-child {
  border: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 14px 26px -20px rgba(22, 32, 51, 0.55);
}

.why-premium-mobile-card p {
  line-height: 1.55;
}

@keyframes whyFadeUp {
  from {
    opacity: 0;
    transform: translateY(16px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes whyFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

@keyframes heroSheen {
  0%, 16% {
    transform: translateX(-68%) skewX(-14deg);
    opacity: 0;
  }
  26% {
    opacity: 1;
  }
  44%, 100% {
    transform: translateX(62%) skewX(-14deg);
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .hero-sheen::before,
  .why-premium-orb,
  .why-premium-reveal,
  .why-premium-grid > .why-premium-card,
  .why-premium-mobile-card {
    animation: none !important;
    opacity: 1;
  }

  .hero-sheen::before {
    opacity: 0;
  }

  .why-premium-grid > .why-premium-card::after {
    transition: none;
    transform: translateX(-140%);
  }
}

@media (max-width: 640px) {
    .filter-counter-val {
      min-width: 1rem; 
      font-size: 0.8rem;
    }
}

/* ===== TOUR SEARCH FILTER BAR ===== */
.tour-filter-bar {
  padding-top: 0.75rem;
  padding-bottom: 0;
}

@media (max-width: 767px) {
  .tour-filter-bar {
    margin-top: -0.5rem !important;
    padding-top: 0;
  }

  .tour-filter-card {
    padding: 1.1rem 1rem 1rem;
    border: 1px solid rgba(226, 232, 240, 0.92);
    border-radius: 1.5rem;
    box-shadow: 0 24px 48px -28px rgba(15, 23, 42, 0.6);
    backdrop-filter: blur(14px);
  }

  .filter-heading {
    padding-bottom: 0.85rem;
    border-bottom: 1px solid #eef2f7;
  }

  .filter-heading > span {
    width: 2rem;
    height: 2rem;
    flex: 0 0 auto;
  }

  .filter-subtitle {
    margin-top: 0.1rem;
    line-height: 1.35;
  }

  .filter-month-list {
    margin-right: -1rem;
    margin-left: -0.1rem;
    padding: 0 1rem 0.25rem 0.1rem;
    flex-wrap: nowrap;
    overflow-x: auto;
    overscroll-behavior-inline: contain;
    scroll-snap-type: x proximity;
    scrollbar-width: none;
  }

  .filter-month-list::-webkit-scrollbar {
    display: none;
  }

  .filter-month-pill {
    min-width: 3.25rem;
    min-height: 2.5rem;
    padding: 0.45rem 0.85rem;
    border-color: #e8edf3;
    border-radius: 0.8rem;
    font-size: 0.75rem;
    scroll-snap-align: start;
  }

  .filter-room-section {
    padding-top: 0.15rem;
  }

  .filter-room-summary {
    gap: 0.75rem;
  }

  .filter-room-summary > div {
    width: 100%;
    justify-content: space-between;
  }

  .filter-room-summary p,
  .filter-room-summary button {
    font-size: 0.7rem;
  }

  .filter-room-card {
    position: relative;
    padding: 0.75rem;
    border-color: #dbe3ec;
    border-radius: 1rem;
    background: #f8fafc;
  }

  .filter-room-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.55rem;
  }

  .filter-room-name {
    grid-column: 1 / -1;
    width: auto;
    color: #334155;
    font-size: 0.72rem;
  }

  .filter-guest-field {
    min-width: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 0.3rem;
  }

  .filter-guest-field span {
    font-size: 0.65rem;
  }

  .filter-guest-field select {
    width: 100%;
    min-width: 0;
    height: 2.6rem;
    padding: 0 0.6rem;
    border-color: #d7e0ea;
    border-radius: 0.7rem;
    background-color: #fff;
    font-size: 0.8rem;
  }

  .filter-room-grid > button {
    position: absolute;
    right: 0.85rem;
  }

  .filter-search-btn {
    height: 3rem;
    border-radius: 0.9rem;
    background: linear-gradient(135deg, #243653, #344968);
    box-shadow: 0 14px 28px -18px rgba(36, 54, 83, 0.9);
    font-size: 0.85rem;
  }
}

.filter-month-pill {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}

.filter-counter-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 9999px;
  border: 1px solid rgba(255,255,255,0.18);
  background: rgba(255,255,255,0.06);
  color: #323232;
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1;
  transition: background 0.18s, border-color 0.18s, transform 0.1s;
  cursor: pointer;
}
.filter-counter-btn:hover {
  background: rgba(180,122,22,0.25);
  border-color: theme('colors.accent.400');
}
.filter-counter-btn:active {
  transform: scale(0.93);
}

.filter-counter-val {
  min-width: 1.5rem;
  text-align: center;
  color: #323232;
  font-weight: 700;
  font-size: 0.9rem;
}

.filter-age-select option {
  background: theme('colors.brand.900');
  color: #323232;
}

.filter-search-btn {
  letter-spacing: 0.01em;
}

/* Transition for child ages panel */
.filter-ages-enter-active,
.filter-ages-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.filter-ages-enter-from,
.filter-ages-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

@media (min-width: 768px) and (max-width: 1439px) {
  .home-priority-grid {
    padding-inline: clamp(1.5rem, 2.5vw, 2rem);
  }
}
</style>
<script setup>
definePageMeta({ layout: 'home' })

import { computed, onMounted, reactive, ref, watch } from 'vue';
import { Carousel, Slide, Pagination } from 'vue3-carousel'
import HomeHeroCarousel from "@/components/home/HomeHeroCarousel.vue";
import { buildUmrahSeoStrategy } from '~/utils/umrahSeoStrategy'
const router = useRouter()
const { tours, searchQuestions } = useInfo()
const { locale } = useI18n()
const { goPath, getPath, getIsMobile } = useCommon();
const isMobile = useIsMobile();
const config = useRuntimeConfig();
const pageCopy = computed(() => locale.value === 'en'
  ? {
      filterTitle: 'Find Your Ideal Umrah Tour',
      filterSubtitle: 'Select your preferences and compare programs.',
      selectMonth: 'Select Month',
      roomAndGuests: 'Rooms and guests',
      room: 'room',
      adult: 'adult',
      child: 'child',
      baby: 'Infant',
      babyLower: 'infant',
      adultCount: 'room adult count',
      childCount: 'room child count',
      babyCount: 'room infant count',
      addRoom: 'Add room',
      removeRoom: 'Remove room',
      searchTours: 'Search Tours',
      childAges: 'Enter the children’s ages (0–17)',
      selectAge: 'Select age',
      age: 'years',
      removeChild: 'Remove child',
      trustAriaLabel: 'Inanc Tour trust and experience facts',
      umrahGuideCta: 'Umrah tour selection guide',
      whyBadge: 'Why Inanc Tour',
      whyHeading: 'A Trusted Standard for Your',
      whyHeadingAccent: 'Umrah Journey',
      whyDescription: 'From guidance and hotel selection to flight planning and service quality, we manage the entire journey transparently and to high standards.',
      getDetails: 'Get More Information',
    }
  : {
      filterTitle: 'En İyi Umre Turunu Bul',
      filterSubtitle: 'Tur bilgilerini seç, programları karşılaştır.',
      selectMonth: 'Ay Seç',
      roomAndGuests: 'Oda ve kişi seçimi',
      room: 'oda',
      adult: 'yetişkin',
      child: 'çocuk',
      baby: 'Bebek',
      babyLower: 'bebek',
      adultCount: 'oda yetişkin sayısı',
      childCount: 'oda çocuk sayısı',
      babyCount: 'oda bebek sayısı',
      addRoom: 'Oda ekle',
      removeRoom: 'Odayı kaldır',
      searchTours: 'Tur Ara',
      childAges: 'Çocukların yaşlarını belirtin (0–17)',
      selectAge: 'Yaş seç',
      age: 'yaş',
      removeChild: 'Çocuğu kaldır',
      trustAriaLabel: 'İnanç Turizm güven ve deneyim bilgileri',
      umrahGuideCta: 'Umre turu tavsiye rehberi',
      whyBadge: 'Neden İnanç Tur',
      whyHeading: 'Umre Yolculuğunda',
      whyHeadingAccent: 'Güvenilir Standart',
      whyDescription: 'Rehberlikten otel seçimine, uçuş planından hizmet kalitesine kadar tüm süreci tek bir merkezde, şeffaf ve yüksek standartlarla yönetiyoruz.',
      getDetails: 'Detaylı Bilgi Al',
    })

const promoCopy = computed(() => locale.value === 'en'
  ? {
      umrah: {
        eyebrow: '5-Star',
        title: 'Umrah Tours',
        subtitle: '7, 8 and 10-day program options',
        mobileBullets: ['Turkish Airlines flights', 'High-speed rail transfers', 'Breakfast and dinner buffets'],
        desktopBullets: ['Turkish Airlines flights', 'Hotels within walking distance', 'Breakfast and dinner buffets'],
        cta: 'Explore Tours',
      },
      balkans: {
        eyebrow: '5 nights – 6 days',
        title: 'Balkan Tours',
        subtitle: 'Flights with Turkish Airlines',
        bullets: ['Guidance by Inanc Tour', 'Accommodation in 4 and 5-star hotels', 'Prayer-friendly itineraries and halal dining'],
        cta: 'View Program',
      },
      hajj: {
        badge: 'Premium Hotel',
        eyebrow: 'Hajj Programs',
        title: '2 different Hajj programs',
        subtitle: 'Carefully planned for you.',
        mobileBullets: ['Hotels in prime locations', 'Distinguished scholars', 'Professional local team'],
        desktopBullets: ['Hotels in prime locations', 'Distinguished scholars'],
        cta: 'Details',
      },
      international: {
        eyebrow: 'New Destinations',
        title: 'International Tours',
        bullets: ['Destinations around the world', 'Guidance by Inanc Tour', 'Accommodation in 4 and 5-star hotels', 'Prayer-friendly itineraries and halal dining'],
        cta: 'View Prices',
      },
      private: {
        eyebrow: 'Private Programs',
        title: 'Tailor-Made Umrah',
        subtitle: 'Create your own program.',
        bullets: ['Choose your preferred dates and duration', 'Plan the hotel selection around your needs', 'Flexible packages for families'],
        cta: 'Details',
      },
    }
  : {
      umrah: {
        eyebrow: '5 Yıldızlı',
        title: 'Umre Turları',
        subtitle: '7, 8 ve 10 günlük program seçenekleri ile',
        mobileBullets: ['THY ile uçuşlar', 'Yüksek hızlı tren ile transfer', 'Sabah ve akşam açık büfe'],
        desktopBullets: ['THY ile uçuşlar', 'Yürüme mesafesi konaklama seçenekleri', 'Sabah ve akşam açık büfe'],
        cta: 'Turları İncele',
      },
      balkans: {
        eyebrow: '5 gece – 6 gün',
        title: 'Balkan Turları',
        subtitle: 'THY seferli uçuşlar ile',
        bullets: ['İnanç Tur rehberliği', '4 ve 5 yıldızlı otellerde konaklama', 'Namaz ve helal yemek hassasiyeti'],
        cta: 'Programı Gör',
      },
      hajj: {
        badge: 'Premium Otel',
        eyebrow: 'Hac Programları',
        title: '2 farklı Hac programı',
        subtitle: 'Sizler için özenle planladık.',
        mobileBullets: ['En yakın konumda', 'Seçkin ilahiyatçı kadrosu', 'Profesyonel saha ekibi'],
        desktopBullets: ['En yakın konumda', 'Seçkin ilahiyatçı kadrosu'],
        cta: 'Detaylar',
      },
      international: {
        eyebrow: 'Farklı Rotalar',
        title: 'Yurtdışı Turları',
        bullets: ['Dünyanın farklı noktaları', 'İnanç Tur rehberliği', '4 ve 5 yıldızlı otellerde konaklama', 'Namaz ve helal yemek hassasiyeti'],
        cta: 'Fiyatları Gör',
      },
      private: {
        eyebrow: 'Özel Programlar',
        title: 'Kişiye Özel Umre',
        subtitle: 'Kendi programınızı oluşturun.',
        bullets: ['Tarih ve süreyi siz belirleyin', 'Otel seçimini size göre planlayın', 'Ailelere özel esnek paketler'],
        cta: 'Detaylar',
      },
    })

const promoCards = computed(() => [
  {
    id: 'umrah',
    path: '/tour/umre-turlari',
    tone: 'teal',
    icon: 'fa-solid fa-kaaba',
    ...promoCopy.value.umrah,
    desktopBullets: promoCopy.value.umrah.desktopBullets,
  },
  {
    id: 'hajj',
    path: '/page/hac',
    tone: 'gold',
    icon: 'fa-solid fa-star-and-crescent',
    ...promoCopy.value.hajj,
    desktopBullets: promoCopy.value.hajj.desktopBullets,
  },
  {
    id: 'balkans',
    path: '/tours/rota-balkan-turlari',
    tone: 'navy',
    icon: 'fa-solid fa-compass',
    ...promoCopy.value.balkans,
    mobileBullets: promoCopy.value.balkans.bullets,
    desktopBullets: promoCopy.value.balkans.bullets,
  },
  {
    id: 'private',
    path: '/tour/kisiye-ozel-umre-turlari',
    tone: 'teal-muted',
    icon: 'fa-solid fa-sliders',
    ...promoCopy.value.private,
    mobileBullets: promoCopy.value.private.bullets,
    desktopBullets: promoCopy.value.private.bullets,
  },
])

const currentSeoYear = new Date().getFullYear()
const nextSeoYear = currentSeoYear + 1
const umrahSeasonLabel = `${currentSeoYear}-${nextSeoYear}`
const umrahSeoStrategy = computed(() => buildUmrahSeoStrategy(currentSeoYear, locale.value))
const homeDecisionContent = computed(() => locale.value === 'en'
  ? {
      eyebrow: 'Plan with clarity',
      intro: `${umrahSeasonLabel} Umrah packages from ${umrahSeoStrategy.value.startingPriceLabel}: compare confirmed dates, named hotels, room options, flights and the exact service scope before you reserve.`,
      summaryLabel: 'Inanc Tour service at a glance',
      summaryEyebrow: 'A simple way to compare',
      summary: 'Choose a program by its written details, not a promotional label alone.',
      proofPoints: [
        { icon: 'fa-solid fa-calendar-check', title: 'Confirmed departure', text: 'Review the live date, availability and room arrangement.' },
        { icon: 'fa-solid fa-hotel', title: 'Named services', text: 'See hotel, flight, transfer and meal details together.' },
        { icon: 'fa-solid fa-people-group', title: 'Guided journey', text: 'Assess the group and guidance model before you choose.' },
      ],
      answerEyebrow: 'Direct answer',
      answerHeading: 'What should you compare before choosing an Umrah tour?',
      answerText: 'Compare programs offered for the same date and room occupancy. The hotel names and location, flight itinerary, transfer plan, meals, guidance, included services and written cancellation conditions show the real difference between two packages.',
      checklist: [
        { title: 'Date and room', text: 'Start with the confirmed departure, duration and room occupancy.' },
        { title: 'Service scope', text: 'Check every included and excluded service in writing.' },
        { title: 'Journey support', text: 'Understand the guidance and in-destination operation structure.' },
      ],
      programEyebrow: 'Choose the right route',
      programHeading: 'Explore by travel preference',
      allToursCta: 'Compare all current Umrah tours',
      programCta: 'Explore details',
      programs: [
        { eyebrow: 'Compare current departures', title: 'Umrah Tours', text: 'Review dates, duration, room options and availability in one place.', path: '/tour/umre-turlari', icon: 'fa-solid fa-calendar-days', iconClass: 'bg-teal-50 text-teal-700' },
        { eyebrow: 'Hotel and service focus', title: '5-Star & Luxury Umrah', text: 'Compare named hotels, location, flights and service inclusions.', path: '/tour/5-yildizli-luks-umre-turlari', icon: 'fa-solid fa-hotel', iconClass: 'bg-amber-50 text-amber-700' },
        { eyebrow: 'For a tailored plan', title: 'Private Umrah', text: 'Build a program around your family, group, dates and accommodation needs.', path: '/tour/kisiye-ozel-umre-turlari', icon: 'fa-solid fa-compass', iconClass: 'bg-sky-50 text-sky-700' },
      ],
      guideEyebrow: 'Decision guide',
      guideHeading: 'A practical checklist before reservation',
      guideItems: [
        { title: 'Hotel and room', text: 'Request the hotel name, location, meal plan and room type in writing.' },
        { title: 'Flight and transfers', text: 'Confirm the airline, baggage, connection and airport-to-hotel plan.' },
        { title: 'Price and conditions', text: 'Compare the same date and occupancy; read payment, cancellation and change terms.' },
        { title: 'Personal needs', text: 'Share family, mobility, health or assistance needs during reservation.' },
      ],
      guideCta: 'Open the full Umrah selection guide',
    }
  : {
      eyebrow: 'Net bilgiyle yolculuk planlayın',
      intro: `${umrahSeasonLabel} umre turlarını ${umrahSeoStrategy.value.startingPriceLabel}’den başlayan fiyatlarla; kesin tarih, otel, oda, uçuş ve açıkça yazılmış hizmet kapsamına göre karşılaştırın.`,
      summaryLabel: 'İnanç Turizm hizmet özeti',
      summaryEyebrow: 'Sağlıklı karşılaştırmanın kısa yolu',
      summary: 'Programı net ayrıntılarıyla değerlendirin.',
      proofPoints: [
        { icon: 'fa-solid fa-calendar-check', title: 'Kesin hareket bilgisi', text: 'Güncel tarih, kontenjan ve oda düzenini birlikte inceleyin.' },
        { icon: 'fa-solid fa-hotel', title: 'Açıklanan hizmetler', text: 'Otel, uçuş, transfer ve yemek detaylarını tek yerde görün.' },
        { icon: 'fa-solid fa-people-group', title: 'Hoca ve saha ekibi', text: 'Güçlü bir saha ekibi ve işinin ehli hocalarımızlayolculuk yapın.' },
      ],
      answerEyebrow: 'Kısa cevap',
      answerHeading: 'Umre turu seçerken hangi ayrıntılar karşılaştırılmalı?',
      answerText: 'Aynı tarih ve aynı oda yerleşimindeki programları karşılaştırın. Otel adları ve konumu, uçuş planı, transfer, yemek, rehberlik, fiyata dahil hizmetler ve yazılı iptal koşulları iki paket arasındaki gerçek farkı gösterir.',
      checklist: [
        { title: 'Tarih ve oda', text: 'Kesin hareket tarihi, süre ve odada kalacak kişi sayısıyla başlayın.' },
        { title: 'Hizmet kapsamı', text: 'Dahil ve hariç her hizmeti yazılı olarak doğrulayın.' },
        { title: 'Yolculuk desteği', text: 'Rehberlik ve saha operasyonu yapısını önceden öğrenin.' },
      ],
      programEyebrow: 'Yolculuğunuza göre seçin',
      programHeading: 'İhtiyacınıza uygun programı inceleyin',
      allToursCta: 'Tüm güncel umre turlarını karşılaştırın',
      programCta: 'Ayrıntıları incele',
      programs: [
        { eyebrow: 'Güncel kalkışları karşılaştırın', title: 'Umre Turları', text: 'Tarih, süre, oda seçeneği ve kontenjanı tek yerde inceleyin.', path: '/tour/umre-turlari', icon: 'fa-solid fa-calendar-days', iconClass: 'bg-teal-50 text-teal-700' },
        { eyebrow: 'Otel ve hizmet odağı', title: '5 Yıldızlı & Lüks Umre', text: 'Açıklanan otelleri, konumu, uçuşları ve hizmet kapsamını karşılaştırın.', path: '/tour/5-yildizli-luks-umre-turlari', icon: 'fa-solid fa-hotel', iconClass: 'bg-amber-50 text-amber-700' },
        { eyebrow: 'Size göre planlanan yolculuk', title: 'Kişiye Özel Umre', text: 'Aile, grup, tarih ve konaklama ihtiyacınıza göre program oluşturun.', path: '/tour/kisiye-ozel-umre-turlari', icon: 'fa-solid fa-compass', iconClass: 'bg-sky-50 text-sky-700' },
      ],
      guideEyebrow: 'Karar rehberi',
      guideHeading: 'Rezervasyondan önce pratik kontrol listesi',
      guideItems: [
        { title: 'Otel ve oda', text: 'Otel adı, konumu, yemek planı ve oda tipini yazılı olarak iletiyoruz.' },
        { title: 'Uçuş ve transfer', text: 'Hava yolu, bagaj, aktarma ve havalimanı–otel planını aktarıyoruz.' },
        { title: 'Fiyat ve koşullar', text: 'Aynı tarih ve oda üzerinden karşılaştırın; ödeme, iptal ve değişiklik şartlarını açıkça ifade ediyoruz.' },
        { title: 'Kişisel ihtiyaçlar', text: 'Aile, hareket kısıtlılığı, sağlık veya destek ihtiyaçlarınızı rezervasyonda paylaşın.' },
      ],
      guideCta: 'Umre turu seçim rehberini açın',
    })
const homePremiumUmrahContent = computed(() => locale.value === 'en'
  ? {
      heading: '5-Star, VIP, Luxury and Private Umrah Options',
      intro: 'Compare premium Umrah options by hotel location, group structure, transfers, guidance and date flexibility. These labels do not always describe the same service, so review the exact inclusions of each program before choosing.',
      navigationLabel: 'Premium Umrah options',
      cards: [
        {
          title: '5-Star and Luxury Umrah',
          text: 'Compare Makkah and Madinah hotels, distance, room options, flights and confirmed dates.',
          path: '/tour/5-yildizli-luks-umre-turlari'
        },
        {
          title: 'VIP and Boutique Umrah',
          text: 'See how groups of 20–45, Fairmont Makkah, Turkish Airlines, rail transfers and dedicated field teams form one service standard.',
          path: '/tour/vip-umre-programlari'
        },
        {
          title: 'Private Umrah Programs',
          text: 'Plan an Umrah journey for your family, company or private group with tailored details.',
          path: '/tour/kisiye-ozel-umre-turlari'
        }
      ],
      selectionGuide: 'The best Umrah package is the one that matches your needs with clear hotel, flight, room, guidance and contract details. Compare evidence and service scope, not promotional labels alone.',
      guideHeading: 'How should you compare an Umrah package?',
      guideIntro: 'A reliable comparison starts with the confirmed departure date and continues with the complete service scope. Check the flight itinerary, hotel names and locations, room occupancy, transfers, meals, guidance, visa arrangements, cancellation terms and services excluded from the price together. This makes it easier to understand why two programs with the same duration may have different prices.',
      guideItems: [
        {
          title: 'Duration and itinerary',
          text: 'A 7-day program can suit travellers with limited time, while 10-day and longer options allow a more relaxed schedule. The number of nights, arrival and departure hours, time spent in Makkah and Madinah and any intercity transfer should be read from the detailed itinerary rather than inferred only from the package name.'
        },
        {
          title: 'Hotel location and room choice',
          text: 'Star rating alone does not explain the complete accommodation experience. Review the hotel name, walking or shuttle distance to the Haram, meal plan and room occupancy. Single, double, triple and quadruple rooms have different per-person prices, and the selected room type should be clearly stated before booking.'
        },
        {
          title: 'Flights, transfers and guidance',
          text: 'Check the operating airline, baggage allowance, direct or connecting flight information and airport transfer plan. In-destination transport, high-speed train or bus arrangements and the size and experience of the guidance team all affect both comfort and the practical flow of the journey.'
        },
        {
          title: 'Price, availability and payment',
          text: 'Umrah prices can change with airline capacity, hotel availability, exchange rates, travel season and room selection. Compare offers issued for the same date and occupancy, confirm what the price includes, and review deposit, balance payment, cancellation and amendment conditions before making a decision.'
        },
        {
          title: 'Documents and preparation',
          text: 'Passport validity, visa requirements and official travel rules should be checked for the selected departure. Travellers should also plan suitable clothing, essential medicines, luggage and communication needs. Families with children, older travellers and passengers requiring assistance should share those needs during reservation.'
        },
        {
          title: 'Questions to ask before booking',
          text: 'Request the confirmed hotel names, exact flight details, room category, meal plan, group size, guide information and all included or excluded services in writing. A transparent program and contract help you compare alternatives accurately and reduce uncertainty before departure.'
        },
        {
          title: 'Travel season and departure date',
          text: 'Demand, weather conditions and the calendar in Saudi Arabia can change the experience as well as availability. School holidays, Ramadan and other busy periods may fill earlier, while different months can offer a quieter program. Compare only confirmed departures, allow enough time for documents and personal preparation, and do not rely on an old price or itinerary when selecting a new date. The current detail page and written offer should identify the services and conditions that apply to that specific departure.'
        }
      ],
      guideClosing: 'Start with the current tour list to compare confirmed dates and package details. Because availability and prices may change, the information shown for a specific departure and the written reservation documents should be treated as the final reference.'
    }
  : {
      heading: '5 Yıldızlı, VIP, Lüks, Delüks ve Butik Umre Seçenekleri',
      intro: 'İnanç Turizm’de 5 yıldızlı umre, lüks umre, VIP umre, delüks umre ve butik umre seçeneklerini; otel konumu, grup yapısı, transfer, rehberlik ve tarih esnekliğine göre inceleyebilirsiniz. Bu tanımlar her zaman aynı hizmeti ifade etmez; seçim yaparken programın açıklanan kapsamını esas alın.',
      navigationLabel: 'Konfor ve hizmet türüne göre umre programları',
      cards: [
        {
          title: '5 Yıldızlı ve Lüks Umre Turları',
          text: 'Mekke ve Medine otellerini, mesafeleri, oda seçeneklerini, uçuşları ve kesin tarihleri karşılaştırın.',
          path: '/tour/5-yildizli-luks-umre-turlari'
        },
        {
          title: 'VIP ve Butik Umre Programları',
          text: '20–45 kişilik grup, Fairmont Mekke, THY, hızlı tren ve geniş saha ekibinden oluşan hizmet standardımızı inceleyin.',
          path: '/tour/vip-umre-programlari'
        },
        {
          title: 'Delüks Umre Nedir?',
          text: 'Delüks, lüks ve standart umre programları arasındaki hizmet ve konaklama farklarını öğrenin.',
          path: '/page/delux-umre-konsepti'
        }
      ],
      selectionGuide: 'En iyi umre turu yalnızca en yüksek fiyatlı program değildir. En iyi umre turları ve en iyi umre firmaları araştırılırken otel mesafesi, uçuş planı, oda tipi, rehberlik, sözleşme ve fiyata dahil hizmetler birlikte değerlendirilmelidir.',
      guideHeading: 'Umre turu seçerken programlar nasıl karşılaştırılmalı?',
      guideIntro: 'Sağlıklı bir karşılaştırma kesinleşmiş hareket tarihiyle başlar ve hizmet kapsamının tamamını içerir. Uçuş planı, otel adları ve konumları, oda yerleşimi, transferler, yemekler, rehberlik, vize işlemleri, iptal koşulları ve fiyata dahil olmayan hizmetler birlikte incelenmelidir. Böylece aynı süreye sahip iki program arasında neden fiyat farkı bulunduğu daha açık biçimde anlaşılır.',
      guideItems: [
        {
          title: 'Tur süresi ve günlük program',
          text: '7 günlük umre turları zamanı sınırlı misafirler için uygun olabilir; 10 günlük ve daha uzun programlar ise ibadet ve dinlenme zamanını daha geniş bir takvime yayar. Yalnızca tur adındaki gün sayısına bakmak yerine geceleme sayısını, varış ve dönüş saatlerini, Mekke ile Medine’de geçirilecek süreyi ve şehirler arası geçiş planını kontrol edin.'
        },
        {
          title: 'Otel konumu ve oda seçimi',
          text: 'Otelin yıldız sayısı konaklama deneyimini tek başına açıklamaz. Otelin adını, Harem’e yürüme veya servis mesafesini, yemek planını ve odada kaç kişinin kalacağını inceleyin. Tek, iki, üç ve dört kişilik odaların kişi başı fiyatları farklıdır; rezervasyondan önce seçilen oda türünün sözleşmede açıkça yazılması gerekir.'
        },
        {
          title: 'Uçuş, transfer ve rehberlik',
          text: 'Uçuşu gerçekleştiren hava yolu, bagaj hakkı, direkt veya aktarmalı sefer bilgisi ve havalimanı transfer planı önemlidir. Suudi Arabistan içindeki otobüs ya da hızlı tren düzeni, ziyaret programları, grubun büyüklüğü ve rehber ekibinin tecrübesi hem yolculuk konforunu hem de programın düzenli ilerlemesini doğrudan etkiler.'
        },
        {
          title: 'Fiyat, kontenjan ve ödeme koşulları',
          text: 'Umre fiyatları hava yolu kapasitesi, otel müsaitliği, döviz kuru, seyahat dönemi ve oda seçimine göre değişebilir. Teklifleri aynı tarih ve aynı oda yerleşimi üzerinden karşılaştırın; vize, uçuş, konaklama, transfer, yemek ve rehberlik hizmetlerinden hangilerinin fiyata dahil olduğunu doğrulayın. Kapora, kalan ödeme, iptal ve değişiklik şartlarını karar vermeden önce okuyun.'
        },
        {
          title: 'Belge ve yolculuk hazırlığı',
          text: 'Pasaport geçerlilik süresi, vize için gereken belgeler ve güncel resmî seyahat kuralları seçilen hareket tarihi için ayrıca kontrol edilmelidir. Mevsime uygun kıyafet, düzenli kullanılan ilaçlar, bagaj ve iletişim ihtiyaçları önceden planlanmalıdır. Çocuklu aileler, ileri yaştaki misafirler ve desteğe ihtiyaç duyan yolcular özel ihtiyaçlarını rezervasyon sırasında bildirmelidir.'
        },
        {
          title: 'Rezervasyondan önce sorulacak sorular',
          text: 'Kesin otel adlarını, uçuş saatlerini, oda kategorisini, yemek düzenini, tahmini grup büyüklüğünü, rehberlik yapısını ve dahil ya da hariç tüm hizmetleri yazılı olarak isteyin. Açık program bilgisi ve ayrıntılı sözleşme, seçenekleri doğru karşılaştırmayı kolaylaştırır ve yolculuk öncesindeki belirsizlikleri azaltır.'
        },
        {
          title: 'Seyahat dönemi ve hareket tarihi',
          text: 'Talep yoğunluğu, hava koşulları ve Suudi Arabistan’daki takvim hem kontenjanı hem de yolculuk deneyimini değiştirebilir. Sömestr, Ramazan ve diğer yoğun dönemlerde programlar daha erken dolabilir; farklı aylarda ise daha sakin bir seyahat düzeni bulunabilir. Yalnızca kesinleşmiş hareket tarihlerini karşılaştırın, belge ve kişisel hazırlık için yeterli zaman bırakın, yeni bir tarih seçerken eski fiyat ya da program bilgisini esas almayın. Güncel detay sayfası ve yazılı teklif, o harekete özel hizmetleri ve geçerli koşulları açıkça göstermelidir.'
        }
      ],
      guideClosing: 'Kesinleşmiş tarihleri ve program ayrıntılarını karşılaştırmak için güncel tur listesini kullanabilirsiniz. Kontenjan ve fiyatlar değişebildiği için belirli bir hareket tarihinin detay sayfasında gösterilen bilgiler ile rezervasyon sırasında sunulan yazılı belgeler nihai referans kabul edilmelidir.'
    }
)


const accordions = {
  en: [
    {
      "title": "Why İnanç Tour?",
      "description": "For years, we have been organizing Hajj and Umrah tours packages without compromising on quality. Many institutions and well-known individuals in Turkey have performed their Umrah pilgrimage under our guidance. We are also proud to serve Muslims worldwide in the Holy Lands. As İnanç Tour, offering the best Umrah tour packages, we now guide you in discovering unique destinations globally.\n\nIn addition to Umrah tours, we take you to enchanting places from Bosnia and Herzegovina to Uzbekistan, from Egypt to Spain.\n\nPersonalized Experience: With our specially designed tours, we ensure you live your travels the way you desire.\n\nSafe and Comfortable Travel: When you travel with us, your safety and comfort are our top priority. We arrange everything with every detail in mind.\n\nFilled with Memories: When you travel with İnanç Tour, you will discover not just places but also touch your hearts. You will gather unforgettable memories."
    },
    {
      title: `When Will the ${umrahSeasonLabel} Umrah Packages Start?`,
      description: `Our ${umrahSeasonLabel} Umrah packages are published as departure dates are confirmed. Programs generally start a few weeks after Eid al-Adha and continue throughout the year. Dates may change according to official Saudi Arabian travel arrangements; follow our current tour list or contact our customer service for confirmed availability.`,

    },
    {
      title: "How long have you been in service?",
      description: "With 21 years of Umrah organization experience, İnanç Tour has served more than 30,000 Umrah pilgrims and accompanies approximately 3,500 pilgrims each year. Since reorganizing as İnanç Tourism in 2011, our professional team has continued to plan Umrah, Hajj and international tours with close attention to spiritual sensitivities, safety and service quality."
    },
    {
      title: "What is the Umrah Tour?",
      description: "Umrah is a pilgrimage to Mecca, which can be performed at any time of the year. It is a spiritual journey that Muslims undertake to seek closeness to Allah and fulfill their religious duties. The Umrah tour includes various services such as accommodation, transportation, and guidance to ensure a smooth and fulfilling experience for pilgrims."
    },
    {
      title: "What are the Umrah Tour Prices?",
      description: "Umrah tour prices vary based on factors such as accommodation type, travel dates, and included services. To get accurate pricing information, please visit our website or contact our sales consultants."
    },
    {
      "title": "Who Are We?",
      "description": "With 21 years of Umrah organization experience, İnanç Tour has served more than 30,000 Umrah pilgrims and accompanies approximately 3,500 pilgrims each year. Since reorganizing as İnanç Tourism in 2011, our professional team has continued to plan Umrah, Hajj and international tours with close attention to spiritual sensitivities, safety and service quality."
    },
    {
      "title": "How Can I Make a Reservation?",
      "description": "Determining Date and Budget: Decide on the dates you wish to travel and the budget you can allocate for the tour. This will help you find tours that suit your dates and costs.\n\nMaking a Reservation: You can make a reservation by visiting the official website of the tour company or by contacting them by phone. Travel agencies or online travel platforms can also assist you in making a reservation. Here are some steps to consider when making a reservation:\n\n- Choose the tour dates and duration.\n- Review the tour content and price.\n- Fill out the reservation form. This may include your name, contact details, and any special requests.\n- Check payment options and policies. You may need to pay a deposit.\n\nDocuments and Preparations: Once the reservation process is complete, the tour company will send you the reservation confirmation and other necessary documents. Do not forget to prepare your travel documents and preparations, such as passport, visa, travel insurance, and necessary health documents.\n\nEnjoy the Tour: Once the reservation process is complete, just enjoy your trip and collect beautiful memories! When going on the tour, make sure you haven't forgotten your luggage and necessary documents."
    },
    {
      "title": "How Can I See Prices and Make Payments?",
      "description": "You can see the price of each Umrah tour in the tours packages section. Umrah prices vary depending on the tour hotel and date. You can make your payments by cash or credit card. For detailed information, please contact our sales consultants."
    }
  ],
  tr: [
    {
      title: 'Neden İnanç Tur\'u tercih etmeliyim? ',
      description: ` <p class='font-semibold text-sm'>İnanç Tur - Hac ve Umre Turları</p>
                <p class='text-sm'>Yıllardır kaliteli hizmetimizden ödün vermeden hac ve umre turları düzenliyoruz. Türkiye'de birçok kurum, şirket, bayi ve tanınmış kişi, umre ibadetini bizim rehberliğimizde gerçekleştirdi. Bununla beraber, dünyanın dört bir yanından gelen Müslümanlara da Kutsal Topraklarda hizmet vermekten büyük bir gurur duyuyoruz.</p>
                <p class='text-sm'>Vip, Delüx ya da Lüks gibi kelimeleri kabul etmiyoruz. Biz kaliteyi lüks değil, standart haline getiriyoruz. Yıllardır kaliteyi standart haline getirerek, 5 yıldızlı yakın otellerle iyi anlaşmalar yaparak, iyi havayollarını tercih ederek, iyi rehberler ve hocalarla çalışarak, en iyi olmaya çalışıyoruz. Tüm bunları yaparak  gerçekten avantajlı umre fiyatarı sunarak kalitenin daha geniş kesimlere ulaşmasını hedefliyoruz. </p>
                <p class='text-sm'>En iyi umre turu paketlerini sunmaya çalışmanın yanında, dünya genelinde benzersiz destinasyonları keşfetmeniz için sizlere rehberlik ediyoruz. Umre turlarının yanında, Bosna Hersek\'ten Özbekistan\'a, Mısır\'dan İspanya\'ya kadar birçok destinasyona tur düzenliyoruz.</p> `,
    },
    {
      title: 'En iyi umre şirketi hangisi?',
      description: `<p class="text-sm"><strong>“En iyi umre şirketi hangisi?”</strong> sorusunun herkes için geçerli tek bir cevabı yoktur. İhtiyaçlarınıza en uygun şirketi belirlemek için programları aynı hizmet kapsamıyla karşılaştırmanız gerekir.</p>
        <p class="text-sm"><strong>En iyi umre tur şirketleri</strong> araştırılırken TÜRSAB yetki belgesi, Mekke ve Medine’de kalınacak otellerin açık adları ve Haremeyn’e mesafeleri, kesin uçuş planı, oda tipi, rehberlik kadrosu, fiyata dahil hizmetler, iptal koşulları ve doğrulanabilir misafir yorumları birlikte incelenmelidir.</p>
        <p class="text-sm">İnanç Turizm’i değerlendirirken TÜRSAB 7677 numaralı seyahat acentası belgemizi, 21 yıllık organizasyon deneyimimizi, açık program ve fiyat bilgilerimizi diğer seçeneklerle karşılaştırabilirsiniz. Ayrıntılı ölçütler için <a href="/page/en-iyi-umre-turu-nasil-secilir" class="font-semibold text-sky-700 underline">umre turu seçim rehberimizi</a> inceleyebilirsiniz.</p>`,
    },
    // {
    //   title: `${currentSeoYear} Umre Turları Ne Zaman Başlayacak?`,
    //   description:
    //     `${currentSeoYear}-${nextSeoYear} sezonu umre programlarımız, kalkış tarihleri kesinleştikçe yayınlanmaktadır. Umre turlarımız genellikle Kurban Bayramı'ndan birkaç hafta sonra başlar ve yıl boyunca devam eder. Kesin kalkışlar, güncel fiyatlar ve kontenjan bilgisi için tur listemizi inceleyebilir veya müşteri hizmetlerimizle iletişime geçebilirsiniz.`,
    // },
     {
      title: 'Neden Mekke\'de tek otel seçeneği sunuyorsunuz ?',
      description:
        `Mekke'de tek otel seçeneği sunmamızın nedeni, misafirlerimize en iyi hizmeti ve konforu sağlamak için otel seçiminde kaliteyi ön planda tutmamızdır. Farimont Clock Royal Tower Hotel Harem-i Şerife en yakın otellerden biridir ve bölgenin en prestijli birkaç otelinden biridir. Bu otel, misafirlerimize Kabe'ye yakın konumda konforlu ve kaliteli bir konaklama deneyimi sunar. Ayrıca, otel ile yaptığımız güçlü anlaşmalar sayesinde, misafirlerimize avantajlı fiyatlar sunmamızı sağlar. Mekke'de tek otel seçeneği sunarak, misafirlerimize yüksek standartlarda hizmet ve konfor sağlamak için çaba gösteriyoruz.`,
    },
    {
      title: 'Ne zamandan beri hizmet vermektesiniz ?',
      description:
        `21 yıllık turizm hikayesi olan İnanç Turizm kurucuları, 2011 yılında yeniden şirketleşme ile İnanç Turizm olarak umre turları ve yurtdışı turları organize ediyor. İşinde profesyonel ekimiz, manevi hassasiyetlere azami özen göstererek umre ve hac programlarını organize ediyor. İnanç Turizm bir tur şirketi olarak bu güzel ve kutlu yolculukta yılların deneyimi ve güvenilir bir hizmet ile, size seyahatin en iyisini sunmayı amaçlıyor.`,
    },
    {
      title: 'Nasıl rezervasyon yapabilirim ? ',
      description:
        `<span class="text-sm"> 
                <p class="font-semibold text-sm">Tarih ve Bütçe Belirleme</p>
                <p class="text-sm">Hangi tarihlerde seyahat etmek istediğinizi ve tur için ayırabileceğiniz bütçeyi belirleyin. Bu, size uygun tarihlerde ve maliyetlerde turları ararken yardımcı olacaktır.</p> 
                <p class="font-semibold text-sm">Rezervasyon İşlemi</p>
                <p class="text-sm mb-1">Whatsapp ya da  telefonla iletişime geçerek rezervasyon yapabilirsiniz. Ayrıca sitemiz üzerinedn online ön rezervasyon yapabilirsiniz. İşte rezervasyon yaparken dikkate almanız gereken bazı adımlar:</p>
            
                  <span class="list-decimal text-sm my-0 ml-4 pl-4 text-sm leading-4">
                    <p class="text-sm leading-4 mb-1">&#9900; Tur tarihlerini ve süresini seçin.</p>
                    <p class="text-sm leading-4 my-1">&#9900; Turun içeriğini ve fiyatını gözden geçirin.</p> 
                    <p class="text-sm leading-4 my-1">&#9900; Rezervasyon formunu doldurun ya da müşteri temsilcimizle iletişime geçiniz. Bu, adınızı, iletişim bilgilerinizi ve varsa özel taleplerinizi içerebilir.</p>
                    <p class="text-sm leading-4 mt-1">&#9900; Ödeme seçeneklerini ve politikalarını kontrol edin. Başlangıçta bir ödeme yapmanız gerekiyor.</p>
                  </span> 

                <p class="font-semibold text-sm">Belgeler ve Hazırlıklar</p>
                <p class="text-sm">Rezervasyon işlemi tamamlandığında,  size rezervasyon onayını ve diğer gerekli belgeleri göndereceğiz. Rezervasyonu için katılımcıların ad soyadları, TC kimlik no ve doğum tarihleri gerekmektedir. Vize alabilmemiz için pasaportunuz gerekmektedir.</p>
              
               </span>`,
    },
    {
      title: 'Umre Paket Fiyatlarınız Ne Kadar?',
      description:
        `<a href='/tour/umre-turlari' title='Umre Fiyatları ${currentSeoYear}'>Umre fiyatlarımız</a>, seçilen tarihlere, otel kategorisine ve diğer hizmetlere bağlı olarak değişiklik göstermektedir. Güncel fiyatlar ve detaylı bilgi için lütfen müşteri hizmetlerimizle iletişime geçiniz.  `,
    },
    {
      title: 'Fiyatları nasıl görebilirim ve  nasıl ödeme yapabilirim ?',
      description:
        "Her bir umre turunun fiyatını turlar bölümünde görebilirsiniz. Umre fiyatları, tur otel ve tarihe göre değişiklik göstermektedir. Yetişkin bireyler için, çocuk ve bebekler için fiyatlar farklılık göstermektedir. Ayrıca ikili oda, üçlü oda, dört kişilik oda ya da single oda konaklamaları için fiyatlarda farklılıklar olmaktadır. Detaylı bilgi için satış danışmanlarımızla iletişime geçiniz. Ödemelerinizi, Nakit veya Kredi Kartı ile ödemeleriniz gerçekleştirebilirisiz. ",
    },
    {
      title: 'Umre Seyahat Sigortası Sağlıyor musunuz?',
      description:
        "Evet, umre paketlerimizde zorunlu seyahat sigortası dahildir. Bu sigorta, sağlık sorunları, bagaj kaybı ve diğer acil durumlar için güvence sağlar.",
    },
    {
      title: 'Umreye Gitmeden Önce Bilinmesi Gerekenler Nelerdir?',
      description:
        "Umreye gitmeden önce erkekler için ihram kuralları, tavaf ve sa'y hakkında bilgi sahibi olunmalıdır. Ayrıca, sağlık kontrollerinin yapılması ve gerekli aşıların tamamlanması önemlidir. Düzenli kullandığınız ilaçlar varsa lütfen yanınızda bulundurmayı unutmayın.  \n\nUmre sırasında, Kabe'yi tavaf ederken ve sa'y yaparken belirli kurallara uymak önemlidir. Tüm detaylar için <a href=\"/page/umre-rehberi\" class=\"text-sky-600\"> umre rehberi</a> sayfamızdan yardım alabilirsiniz.",
    },
    {
      title: 'Umre Ziyareti İçin Hangi Tarihler Uygundur?',
      description:
        "Umre ziyaretleri 'Hac dışında' yılın her döneminde yapılabilir. Ancak Ramazan ayı ve kış dönemi daha yoğun olur. Sıcaklıkların arttığı yaz umre dönemi gibi nispeten sakin sezonlarda daha uygun fiyatlarla seyahat edebilirsiniz. Umre turlarımız, yıl boyunca farklı tarihlerde düzenlenmektedir. Detaylı bilgi için lütfen müşteri hizmetlerimizle iletişime geçiniz.",
    },
    {
      title: 'Umre Vizesi İçin Gerekli Belgeler Nelerdir?',
      description:
        "Umre vizesi için (tur dönüş tarihine göre en az  6 ay geçerlilik süresi olan) pasaport gereklidir. Bize pasaportunuzun fotoğrafını göndermeniz yeterlidir.",
    },
    {
      title: 'Umre Rehberlik Hizmetleriniz Hakkında Bilgi Verebilir misiniz ?',
      description:
        "Rehberlik hizmetlerimiz, ibadetlerin doğru ve eksiksiz bir şekilde yerine getirilmesi ve Suudi Arabistan'da bulunduğunuz süre boyunca size yardımcı olmak  için deneyimli rehber hocalarımız tarafından sunulmaktadır. Mekke ve Medine'deki tüm ziyaretleriniz boyunca yanınızda rehberlerimiz yer almaktadır. Ayrıca, saha görevlilerimiz ve rehberlerimiz serbest zamanlarınızda gün içinde sizelere destek olmaktadır.",
    },
  ],

};



const activeCommentIndex = ref(0);

const activeWhyTab = ref('guidance')
const whyReasons = computed(() => locale.value === 'en'
  ? [
      {
        key: 'guidance',
        order: 1,
        tab: 'Guidance',
        title: 'Experienced Guidance System',
        description: 'Our experienced guides provide clear direction, information and coordination throughout every stage of worship.',
        bullets: ['A team familiar with every stage in Makkah and Madinah', 'Clear guidance through each act of worship', 'Fast communication support for group coordination'],
        img: '/assets/img/banners/premium-image-1.png',
      },
      {
        key: 'hotels',
        order: 2,
        tab: 'Hotels',
        title: 'Comfortable Hotels in Prime Locations',
        description: 'We plan accommodation around your needs, combining high standards with convenient access.',
        bullets: ['Five-star, high-standard hotel options', 'Locations close to transport and places of worship', 'Room types for families and groups'],
        img: '/assets/img/banners/premium-image-2.png',
      },
      {
        key: 'flights',
        order: 3,
        tab: 'Flights',
        title: 'Reliable, Well-Planned Flights',
        description: 'We coordinate travel dates, connections and operational details to make your journey more comfortable.',
        bullets: ['Planning around regular departure periods', 'Airport and transfer coordination', 'Updates and support throughout the journey'],
        img: '/assets/img/banners/premium-image-3.png',
      },
      {
        key: 'quality',
        order: 4,
        tab: 'Service Quality',
        title: 'End-to-End Service Quality',
        description: 'From your first enquiry until your return, we provide transparent, measurable service focused on guest satisfaction.',
        bullets: ['Transparent information throughout the process', 'Responsive, solution-focused support', 'Continuous improvement driven by guest satisfaction'],
        img: '/assets/img/banners/premium-image-4.png',
      },
    ]
  : [
      {
        key: 'guidance',
        order: 1,
        tab: 'Rehberlik',
        title: 'Deneyimli Rehberlik Sistemi',
        description: 'Tüm ibadet süreci boyunca alanı bilen rehberlerimizle yönlendirme, bilgilendirme ve koordinasyon desteği sağlıyoruz.',
        bullets: ['Mekke ve Medine süreç akışına hakim ekip', 'İbadet adımlarında açık ve sade yönlendirme', 'Grup organizasyonunda hızlı iletişim desteği'],
        img: '/assets/img/banners/premium-image-1.png',
      },
      {
        key: 'hotels',
        order: 2,
        tab: 'Oteller',
        title: 'Konforlu ve Yakın Otel Seçenekleri',
        description: 'Konaklamada kalite ve erişim kolaylığını birlikte sunan otel alternatifleri ile planlamayı ihtiyaçlarınıza göre yapıyoruz.',
        bullets: ['5 yıldızlı ve yüksek standartlı otel opsiyonları', 'Ulaşım ve ibadet noktalarına yakın konumlar', 'Aileler ve gruplar için farklı konaklama tipleri'],
        img: '/assets/img/banners/premium-image-2.png',
      },
      {
        key: 'flights',
        order: 3,
        tab: 'Uçuşlar',
        title: 'Planlı ve Güvenilir Uçuş Organizasyonu',
        description: 'Uçuş süreçlerini tarih, aktarma ve operasyon detaylarıyla birlikte planlayarak yolculuğu daha konforlu hale getiriyoruz.',
        bullets: ['Düzenli kalkış dönemlerine göre planlama', 'Havalimanı ve transfer koordinasyonu', 'Yolculuk sürecinde bilgilendirme ve takip'],
        img: '/assets/img/banners/premium-image-3.png',
      },
      {
        key: 'quality',
        order: 4,
        tab: 'Hizmet Kalitesi',
        title: 'Uçtan Uca Hizmet Kalitesi',
        description: 'İlk iletişimden dönüşe kadar tüm aşamalarda ölçülebilir hizmet standardı ve memnuniyet odaklı bir deneyim sunuyoruz.',
        bullets: ['Süreç boyunca şeffaf bilgilendirme', 'Hızlı geri dönüş ve çözüm odaklı destek', 'Yüksek memnuniyet hedefi ile sürekli iyileştirme'],
        img: '/assets/img/banners/premium-image-4.png',
      },
    ])

const activeWhyReason = computed(() => {
  return whyReasons.value.find((item) => item.key === activeWhyTab.value) || whyReasons.value[0]
})



useHead({
  link: [
    { rel: 'canonical', href: locale.value === 'en' ? 'https://inanctur.com.tr/en' : 'https://inanctur.com.tr/' },
    // { rel: "preload", as: "image", href: "https://inanctur.com.tr/assets/img/slider/Mostar_360.webp" },
    // { rel: "preload", as: "image", href: "https://inanctur.com.tr/assets/img/kaaba.svg" }, 
    { rel: "alternate", hreflang: "x-default", href: "https://inanctur.com.tr/" },
    { rel: "alternate", hreflang: "tr", href: "https://inanctur.com.tr/" },
    { rel: "alternate", hreflang: "en", href: "https://inanctur.com.tr/en" },
    { rel: 'preconnect', href: 'https://api.inanctur.com.tr', crossorigin: 'anonymous' },
  ]
})

// Burada FAQ Schema için JSON-LD üretiyoruz
const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": locale.value && accordions?.[locale.value] ? accordions?.[locale.value].map(item => ({
    "@type": "Question",
    "name": item.title,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": item.description
    }
  })) : []
}

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': ['Organization', 'TravelAgency'],
  '@id': 'https://inanctur.com.tr/#organization',
  name: 'İnanç Turizm',
  alternateName: ['İnanç Tur', 'Inanc Tour', 'Inanc Travel'],
  url: 'https://inanctur.com.tr/',
  logo: 'https://inanctur.com.tr/assets/img/logo/inanc_tur_yeni_logo.webp',
  email: 'bilgi@inanctur.com.tr',
  telephone: '+90 850 241 41 41',
  description: '21 yıllık umre organizasyonu deneyimiyle yılda yaklaşık 3.500 ve bugüne kadar 30.000’den fazla umre yolcusuna hizmet veren TÜRSAB 7677 belgeli seyahat acentası.',
  identifier: {
    '@type': 'PropertyValue',
    name: 'TÜRSAB Belge No',
    value: '7677'
  },
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Mahmutbey Mah. Taşocağı Yolu Cad. No:1 Polat Tower & Residence Kat 24 D:188',
    addressLocality: 'Bağcılar',
    addressRegion: 'İstanbul',
    postalCode: '34218',
    addressCountry: 'TR'
  },
  sameAs: [
    'https://www.facebook.com/inancturizm',
    'https://www.instagram.com/inanc_turizm/'
  ]
}

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': locale.value === 'en' ? 'https://inanctur.com.tr/en#webpage' : 'https://inanctur.com.tr/#webpage',
  url: locale.value === 'en' ? 'https://inanctur.com.tr/en' : 'https://inanctur.com.tr/',
  name: umrahSeoStrategy.value.home.title,
  description: umrahSeoStrategy.value.home.description,
  inLanguage: locale.value === 'en' ? 'en-US' : 'tr-TR',
  isPartOf: { '@id': 'https://inanctur.com.tr/#website' },
  about: { '@id': 'https://inanctur.com.tr/#organization' },
  primaryImageOfPage: {
    '@type': 'ImageObject',
    contentUrl: 'https://inanctur.com.tr/assets/img/slider/banner_1.webp',
  },
}

const homeProgramListSchema = computed(() => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  '@id': locale.value === 'en' ? 'https://inanctur.com.tr/en#umrah-programs' : 'https://inanctur.com.tr/#umrah-programs',
  name: locale.value === 'en' ? 'Inanc Tour Umrah program options' : 'İnanç Turizm umre program seçenekleri',
  itemListElement: homeDecisionContent.value.programs.map((program, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: {
      '@type': 'WebPage',
      name: program.title,
      description: program.text,
      url: `https://inanctur.com.tr${locale.value === 'en' ? '/en' : ''}${program.path}`,
    },
  })),
}))


if (locale.value == "en") {

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://inanctur.com.tr/#website",
    "name": "İnanç Tur",
    "alternateName": ["İnanç Turizm", "Inanc Travel"],
    "url": "https://inanctur.com.tr/"
  }
  useSeoMeta({
    title: umrahSeoStrategy.value.home.title,
    ogTitle: umrahSeoStrategy.value.home.title,
    description: umrahSeoStrategy.value.home.description,
    keywords: umrahSeoStrategy.value.home.keywords,
    ogDescription: umrahSeoStrategy.value.home.description,
    ogImage: "https://inanctur.com.tr/assets/img/slider/banner_1.webp",
    ogLocale: "en_US",
    ogSiteName: "Inanc Travel",
    ogType: "website",
    twitterCard: 'summary_large_image',
    twitterTitle: umrahSeoStrategy.value.home.title,
    twitterDescription: umrahSeoStrategy.value.home.description,
    twitterImage: 'https://inanctur.com.tr/assets/img/slider/banner_1.webp',
  });

  useHead({
    script: [
      {
        type: 'application/ld+json',
        children: JSON.stringify(organizationSchema),
      },
      {
        type: 'application/ld+json',
        children: JSON.stringify(jsonLd),
      },
      {
        type: 'application/ld+json',
        children: JSON.stringify(webPageSchema),
      },
      {
        type: 'application/ld+json',
        children: () => JSON.stringify(homeProgramListSchema.value),
      },
      {
        type: 'application/ld+json',
        children: JSON.stringify(faqSchema)
      }
    ],
  });
} else {

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://inanctur.com.tr/#website",
    "name": "İnanç Tur",
    "alternateName": ["İnanç Turizm", "Inanc Travel"],
    "url": "https://inanctur.com.tr/"
  }
  useSeoMeta({
    title: umrahSeoStrategy.value.home.title,
    description: umrahSeoStrategy.value.home.description,
    keywords: umrahSeoStrategy.value.home.keywords,
    ogTitle: umrahSeoStrategy.value.home.title,
    ogDescription: umrahSeoStrategy.value.home.description,
    ogImage: "https://inanctur.com.tr/assets/img/slider/banner_1.webp",
    ogSiteName: "Inanc Turizm",
    ogLocale: "tr_TR",
    ogType: "website",
    twitterCard: 'summary_large_image',
    twitterTitle: umrahSeoStrategy.value.home.title,
    twitterDescription: umrahSeoStrategy.value.home.description,
    twitterImage: 'https://inanctur.com.tr/assets/img/slider/banner_1.webp',
  })


  useHead({
    script: [
      {
        type: 'application/ld+json',
        children: JSON.stringify(organizationSchema),
      },
      {
        type: 'application/ld+json',
        children: JSON.stringify(jsonLd),
      },
      {
        type: 'application/ld+json',
        children: JSON.stringify(webPageSchema),
      },
      {
        type: 'application/ld+json',
        children: () => JSON.stringify(homeProgramListSchema.value),
      },
      {
        type: 'application/ld+json',
        children: JSON.stringify(faqSchema)
      }
    ],
  });

}

const searched = ref({
  duration: [],
  where: [],
  when: []
})

const blogs = ref([])
const selectionWhenShow = ref(false)

// ---- Tour Search Filter ----
const createDefaultFilterRoom = (adult = 2) => ({
  adult,
  child: 0,
  baby: 0,
})

const tourFilter = reactive({
  months: [],
  rooms: [createDefaultFilterRoom()],
  childrenAges: [],
})

const totalFilterKidsCount = computed(() => {
  return tourFilter.rooms.reduce((sum, room) => sum + Number(room.child || 0) + Number(room.baby || 0), 0)
})

const filterTotals = computed(() => {
  return {
    rooms: tourFilter.rooms.length,
    adults: tourFilter.rooms.reduce((sum, room) => sum + Number(room.adult || 0), 0),
    children: tourFilter.rooms.reduce((sum, room) => sum + Number(room.child || 0), 0),
    babies: tourFilter.rooms.reduce((sum, room) => sum + Number(room.baby || 0), 0),
  }
})

const filterMonths = computed(() => [
  // { value: '09-26', label: locale.value === 'en' ? 'Sep' : 'Eyl' },
  // { value: '10-26', label: locale.value === 'en' ? 'Oct' : 'Eki' },
  { value: '11-26', label: locale.value === 'en' ? 'Nov' : 'Kas' },
  { value: '12-26', label: locale.value === 'en' ? 'Dec' : 'Ara' },
  { value: '01-27', label: locale.value === 'en' ? 'Jan' : 'Oca' },
  { value: '02-27', label: locale.value === 'en' ? 'Feb' : 'Şub' },
  { value: '03-27', label: locale.value === 'en' ? 'Mar' : 'Mart' },
  // { value: '04-27', label: 'Nis' },
  // { value: '05-27', label: 'May' },
  // { value: '06-27', label: 'Haz' },
])

const toggleFilterMonth = (month) => {
  if (tourFilter.months.includes(month)) {
    tourFilter.months = tourFilter.months.filter((item) => item !== month)
    return
  }
  tourFilter.months.push(month)
}
const isFilterMonthSelected = (month) => {
  return tourFilter.months.includes(month)
}

const normalizeFilterChildrenAges = () => {
  const expectedCount = totalFilterKidsCount.value
  if (tourFilter.childrenAges.length > expectedCount) {
    tourFilter.childrenAges = tourFilter.childrenAges.slice(0, expectedCount)
    return
  }
  while (tourFilter.childrenAges.length < expectedCount) {
    tourFilter.childrenAges.push('')
  }
}

watch(
  () => tourFilter.rooms,
  () => {
    normalizeFilterChildrenAges()
  },
  { deep: true }
)

const addFilterRoom = () => {
  if (tourFilter.rooms.length >= 6) return
  tourFilter.rooms.push(createDefaultFilterRoom())
  normalizeFilterChildrenAges()
}

const removeFilterRoom = (idx) => {
  if (tourFilter.rooms.length <= 1) return
  tourFilter.rooms.splice(idx, 1)
  normalizeFilterChildrenAges()
}

const removeFilterChildFromRooms = (age) => {
  const removeBabyFirst = String(age) === '0'
  for (let i = tourFilter.rooms.length - 1; i >= 0; i -= 1) {
    const room = tourFilter.rooms[i]
    if (removeBabyFirst && room.baby > 0) {
      room.baby -= 1
      return
    }
    if (!removeBabyFirst && room.child > 0) {
      room.child -= 1
      return
    }
  }

  for (let i = tourFilter.rooms.length - 1; i >= 0; i -= 1) {
    const room = tourFilter.rooms[i]
    if (room.child > 0) {
      room.child -= 1
      return
    }
    if (room.baby > 0) {
      room.baby -= 1
      return
    }
  }
}

const removeFilterChildAge = (idx) => {
  const age = tourFilter.childrenAges[idx]
  removeFilterChildFromRooms(age)
  tourFilter.childrenAges.splice(idx, 1)
  normalizeFilterChildrenAges()
}

const resetTourFilter = () => {
  tourFilter.months = []
  tourFilter.rooms = [createDefaultFilterRoom()]
  tourFilter.childrenAges = []
}

const doTourSearch = () => {
  const params = new URLSearchParams()
  if (tourFilter.months.length > 0) params.set('when', tourFilter.months.join(','))
  params.set('adults', String(filterTotals.value.adults))
  params.set('rooms', String(filterTotals.value.rooms))
  const validChildren = tourFilter.childrenAges.filter((age) => age !== '' && age !== null && age !== undefined)
  if (validChildren.length > 0) params.set('children', validChildren.join(','))
  goPath(`/tour/umre-turlari?${params.toString()}`)
}
// ---- End Tour Search Filter ----

const currentSlideInacturFark = ref(0)
const showHomePromoVideo = ref(false)

const startHomePromoVideo = () => {
  showHomePromoVideo.value = true
}
 
const addSearch = (type, value) => {
  if (searched.value[type].find(item => item == value)) {
    searched.value[type] = searched.value[type].filter(item => item != value);
    searchQuestions.value[type] = searchQuestions.value[type].map(item => {
      if (item.id == value) {
        item.selected = false;
      }
      return item;
    })
  } else {
    searched.value[type].push(value)
    searchQuestions.value[type] = searchQuestions.value[type].map(item => {
      if (item.id == value) {
        item.selected = true;
      }
      return item;
    })
  }

}
onMounted(() => {
  const mobileDetected = getIsMobile();
  if (mobileDetected) {
    isMobile.value = true;
  } else if (mobileDetected === false) {
    isMobile.value = false;
  }
  window.__localeId__ = "tr";

  // Blog cards are below the primary search and conversion content. Fetching
  // them only after hydration keeps an external API request off the critical
  // SSR path and preserves the first render's bandwidth for the hero.
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(getBlogs, { timeout: 2000 });
  } else {
    window.setTimeout(getBlogs, 0);
  }
})

const menuIndex = ref(0);
const getBlogs = async () => {
  blogs.value = [];
  try {
    const params = new URLSearchParams({
      lang: locale.value,
      limit: '4',
      offset: '0',
      fields: `id,blog_Link,blog_Title,blog_Stext`,
      filter: JSON.stringify({ blog_TopPage: ["=", "QmxvZ0thdGVnb3JpbGVyMTQ5NTM2NTc0NAqq"], status: ["=", 1] })
    })
    // The REST API expects the sort value as an array (`sort[]`), matching
    // Axios's former parameter serialization. Sending `sort` causes a 500.
    params.append('sort[]', 'pdb_sira,ASC')
    const response = await $fetch(`${config.public.apiBase}/rest/Yazilar?${params.toString()}`)
    blogs.value = response?.formattedData || []
  } catch (error) {
    console.warn('Blog cards could not be loaded:', error)
  }
}
const startSearch = () => {
  let search = searched.value;
  let duration = search['duration'].join(",")
  let when = search['when'].join(",")
  goPath(`/tour/umre-turlari?duration=${duration}&when=${when}`)
}


</script>
